(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8865],{

/***/ "./src/components/SEO/Wiki.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ WikiHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _env_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/env.mjs");
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/react/index.js");




const WikiHeader = (param)=>/*#__PURE__*/ {
    let { slug , title , description , mainImage , datePublished , dateModified , author , noindex =false  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .ArticleJsonLd */ .dX, {
                url: "".concat(_env_mjs__WEBPACK_IMPORTED_MODULE_1__/* .env.NEXT_PUBLIC_DOMAIN */ .O.NEXT_PUBLIC_DOMAIN, "/wiki/").concat(slug),
                title: title,
                images: [
                    mainImage
                ],
                datePublished: datePublished || "",
                dateModified: dateModified || "",
                authorName: author,
                publisherName: "IQWiki",
                publisherLogo: "".concat(_env_mjs__WEBPACK_IMPORTED_MODULE_1__/* .env.NEXT_PUBLIC_DOMAIN */ .O.NEXT_PUBLIC_DOMAIN, "/images/icons/favicon.ico"),
                description: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
                title: title,
                description: description,
                noindex: noindex,
                openGraph: {
                    title,
                    description,
                    images: [
                        {
                            url: "".concat(_env_mjs__WEBPACK_IMPORTED_MODULE_1__/* .env.NEXT_PUBLIC_DOMAIN */ .O.NEXT_PUBLIC_DOMAIN, "/_next/image?url=").concat(mainImage, "&w=1200&q=95")
                        }
                    ]
                }
            })
        ]
    });
};


/***/ }),

/***/ "./src/components/Wiki/WikiPage/WikiMarkup.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ WikiMarkup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/@everipedia/iq-utils/build/module/index.js + 2 modules
var build_module = __webpack_require__("./node_modules/@everipedia/iq-utils/build/module/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 5 modules
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiFields.ts
var getWikiFields = __webpack_require__("./src/utils/WikiUtils/getWikiFields.ts");
// EXTERNAL MODULE: ./src/utils/WalletUtils/getUserAddressFromCache.ts
var getUserAddressFromCache = __webpack_require__("./src/utils/WalletUtils/getUserAddressFromCache.ts");
// EXTERNAL MODULE: ./node_modules/bigpicture/src/BigPicture.js
var BigPicture = __webpack_require__("./node_modules/bigpicture/src/BigPicture.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Elements/MediaPreview/MediaPreview.tsx


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore



const MediaPreview = (param)=>{
    let { type ="IPFS_IMG" , src , children , className , style , onClick , animationStart , animationEnd , onClose , onError , onChangeImage , noLoader , ...rest } = param;
    const elRef = react.useRef(null);
    const isPlayable = type === "IPFS_VID" || type === "YOUTUBE" || type === "VIMEO";
    const zoomHandle = ()=>{
        if (!elRef.current) return;
        const options = {
            el: elRef.current
        };
        switch(type){
            case "IPFS_IMG":
                options.imgSrc = src;
                break;
            case "IPFS_VID":
                options.vidSrc = src;
                break;
            case "YOUTUBE":
                // eslint-disable-next-line prefer-destructuring
                options.ytSrc = src.split("=")[1];
                break;
            case "VIMEO":
                options.vimeoSrc = src.replace(/(https?:\/\/)?(www\.)?vimeo\.com\//, "");
                break;
            default:
                options.imgSrc = src;
                break;
        }
        if (typeof onError === "function") {
            options.onError = onError;
        }
        if (typeof animationStart === "function") {
            options.animationStart = animationStart;
        }
        if (typeof animationEnd === "function") {
            options.animationEnd = animationEnd;
        }
        if (typeof onClose === "function") {
            options.onClose = onClose;
        }
        if (typeof onChangeImage === "function") {
            options.onChangeImage = onChangeImage;
        }
        if (noLoader) {
            options.noLoader = true;
        }
        const bp = (0,BigPicture/* default */.Z)(options);
        // 16:9 ratio with height of window.innerHeight - 200px
        const height = window.innerHeight - 200;
        const width = height * 16 / 9;
        bp.opts.dimensions = [
            width,
            height
        ];
        bp.updateDimensions();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        cursor: "pointer",
        className: "bigpicture link picture ".concat(className || ""),
        onClick: ()=>{
            if (onClick) onClick();
            zoomHandle();
        },
        ref: elRef,
        position: "relative",
        style: {
            display: "inline-block",
            ...style
        },
        ...rest,
        children: [
            isPlayable && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                as: ri_index_esm/* RiPlayLine */.hpr,
                fontSize: "30px",
                position: "absolute",
                zIndex: 999,
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                color: "white",
                bgColor: "whiteAlpha.400",
                borderRadius: "50%",
                p: 1,
                w: 8,
                h: 8
            }),
            children
        ]
    });
};
/* harmony default export */ var MediaPreview_MediaPreview = (MediaPreview);

// EXTERNAL MODULE: ./src/utils/DataTransform/mediaUtils.tsx
var mediaUtils = __webpack_require__("./src/utils/DataTransform/mediaUtils.tsx");
// EXTERNAL MODULE: ./src/components/Elements/Image/Image.tsx
var Image = __webpack_require__("./src/components/Elements/Image/Image.tsx");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
// EXTERNAL MODULE: ./src/styles/markdown.module.css
var markdown_module = __webpack_require__("./src/styles/markdown.module.css");
var markdown_module_default = /*#__PURE__*/__webpack_require__.n(markdown_module);
;// CONCATENATED MODULE: ./src/components/Wiki/WikiAccordion/index.tsx





const WikiAccordion = (param)=>{
    let { title , withNoDarkBg , children , defaultOpen , ...rest } = param;
    const [first, setfirst] = (0,react.useState)(defaultOpen ? (markdown_module_default()).accordionOpen : (markdown_module_default()).accordionDisplay);
    const ChangeStyle = ()=>{
        if (first === (markdown_module_default()).accordionDisplay) {
            setfirst((markdown_module_default()).accordionUnDisplay);
        } else if (first === (markdown_module_default()).accordionUnDisplay) {
            setfirst((markdown_module_default()).accordionDisplay);
        } else if (first === (markdown_module_default()).accordionOpen) {
            setfirst((markdown_module_default()).accordionClose);
        } else {
            setfirst((markdown_module_default()).accordionOpen);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        w: "100%",
        borderWidth: 1,
        bgColor: "wikiCardBg",
        _dark: {
            bgColor: withNoDarkBg ? "gray.800" : "gray.700"
        },
        p: 3,
        borderRadius: 8,
        borderColor: "rankingListBorder",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                cursor: "pointer",
                onClick: ChangeStyle,
                justify: "start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                        color: "linkColor",
                        variant: "link",
                        minW: 3,
                        "aria-label": "toggle".concat(title),
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiArrowDownSLine */.ZXJ, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        style: {
                            userSelect: "none",
                            WebkitUserSelect: "none"
                        },
                        fontSize: "14px",
                        color: "linkColor",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* chakra.div */.m$.div, {
                className: first,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    p: 2,
                    mt: 1,
                    ...rest,
                    children: children
                })
            })
        ]
    });
};
/* harmony default export */ var Wiki_WikiAccordion = (WikiAccordion);

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/InsightComponents/RelatedMedia.tsx







const RELATED_MEDIA_IMAGE_BOX_SIZE = 150;
const RelatedMediaGrid = (param)=>{
    let { media  } = param;
    if (!media || media.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
        w: "100%",
        spacing: 4,
        borderRadius: 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wiki_WikiAccordion, {
            title: "Media",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                columns: {
                    base: 3,
                    xl: 3,
                    sm: 4,
                    md: 6,
                    "2xl": 4
                },
                spacing: 3,
                children: media.map((m, i)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(index_esm/* AspectRatio */.oM, {
                        ratio: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaPreview_MediaPreview, {
                            type: m.source,
                            src: (0,mediaUtils/* constructMediaUrl */.w)(m),
                            bgColor: "dimColor",
                            borderRadius: 4,
                            boxSize: "100%",
                            overflow: "hidden",
                            "data-caption": m === null || m === void 0 ? void 0 : m.caption,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                boxSize: "100%",
                                src: m.source !== "YOUTUBE" ? (0,mediaUtils/* constructMediaUrl */.w)(m) : "https://i3.ytimg.com/vi/".concat(m.name, "/maxresdefault.jpg"),
                                alt: "related media",
                                imgBoxSize: RELATED_MEDIA_IMAGE_BOX_SIZE,
                                hideOnError: true,
                                objectFit: "cover",
                                bgColor: "fadedText2"
                            })
                        }, i)
                    }, i);
                })
            })
        })
    });
};
/* harmony default export */ var RelatedMedia = (RelatedMediaGrid);

// EXTERNAL MODULE: ./src/components/WikiImage.tsx
var WikiImage = __webpack_require__("./src/components/WikiImage.tsx");
// EXTERNAL MODULE: ./src/components/Elements/LinkElements/LinkOverlay.tsx
var LinkOverlay = __webpack_require__("./src/components/Elements/LinkElements/LinkOverlay.tsx");
// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiImageUrl.ts
var getWikiImageUrl = __webpack_require__("./src/utils/WikiUtils/getWikiImageUrl.ts");
// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiSummary.ts
var getWikiSummary = __webpack_require__("./src/utils/WikiUtils/getWikiSummary.ts");
// EXTERNAL MODULE: ./src/services/wikis/index.ts
var wikis = __webpack_require__("./src/services/wikis/index.ts");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/InsightComponents/RelatedWikis.tsx









const RelatedWikiCard = (param)=>{
    let { wiki  } = param;
    const { id , title  } = wiki;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* LinkBox */.fG, {
        w: "100%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
            _hover: {
                bgColor: "dimColor"
            },
            borderRadius: 4,
            p: 3,
            mx: -2,
            align: "start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiImage/* WikiImage */.R, {
                    imageURL: (0,getWikiImageUrl/* getWikiImageUrl */.A)(wiki.images),
                    h: "80px",
                    w: "80px",
                    flexShrink: 0,
                    borderRadius: 4,
                    overflow: "hidden",
                    alt: wiki.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOverlay/* default */.Z, {
                            href: "/wiki/".concat(id),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSize: "16px",
                                wordBreak: "break-word",
                                fontWeight: "500",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontSize: "13px",
                            mt: 0.5,
                            wordBreak: "break-word",
                            children: (0,getWikiSummary/* getWikiSummary */.L)(wiki, getWikiSummary/* WikiSummarySize.Small */.D.Small)
                        })
                    ]
                })
            ]
        })
    });
};
// TODO: even better load only when near viewport
const RelatedWikis = (param)=>{
    let { wikiId , category  } = param;
    var ref;
    const { data  } = (0,wikis/* useGetWikiPreviewsByCategoryQuery */.Z9)({
        category: category,
        limit: 6
    });
    const relatedWikis = (ref = data === null || data === void 0 ? void 0 : data.filter((w)=>w.id !== wikiId)) === null || ref === void 0 ? void 0 : ref.slice(0, 4);
    if (!relatedWikis) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
        w: "100%",
        spacing: 4,
        borderRadius: 2,
        mb: "5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wiki_WikiAccordion, {
            mt: "-3px",
            title: "Related Articles",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
                align: "start",
                w: "100%",
                children: relatedWikis.map((wiki)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedWikiCard, {
                        wiki: wiki
                    }, wiki.id))
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/node_modules/@chakra-ui/color-mode/dist/index.esm.js
var color_mode_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/system/node_modules/@chakra-ui/color-mode/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/index.esm.js
var spinner_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/spinner/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-twitter-embed/dist/index.modern.js
var index_modern = __webpack_require__("./node_modules/react-twitter-embed/dist/index.modern.js");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/InsightComponents/TwitterTimeline.tsx





const TwitterTimeline = (param)=>{
    let { url  } = param;
    const { colorMode  } = (0,color_mode_dist_index_esm/* useColorMode */.If)();
    const twitterTimelineRef = (0,react.useRef)(null);
    const [snapOpen, setSnapOpen] = (0,react.useState)(false);
    const [isLoaded, setIsLoaded] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const observer = new IntersectionObserver((param)=>{
            let [entry] = param;
            if (entry.isIntersecting && !isLoaded) setIsLoaded(true);
        }, {
            root: null,
            rootMargin: "0px",
            threshold: 0.1
        });
        observer.observe(twitterTimelineRef.current);
    }, [
        isLoaded
    ]);
    (0,react.useEffect)(()=>{
        if (isLoaded) {
            setSnapOpen(false);
            const timeout = setTimeout(()=>{
                setSnapOpen(true);
            }, 100);
            return ()=>clearTimeout(timeout);
        }
        return ()=>{};
    }, [
        colorMode,
        isLoaded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
        ref: twitterTimelineRef,
        w: "100%",
        spacing: 4,
        borderRadius: 2,
        mb: "5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wiki_WikiAccordion, {
            title: "Twitter Timeline",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                h: "400px",
                bgColor: "white",
                _dark: {
                    bgColor: "dimColor"
                },
                borderRadius: 12,
                position: "relative",
                overflowY: "scroll",
                children: [
                    snapOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        zIndex: 2,
                        pos: "absolute",
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* TwitterTimelineEmbed */.kV, {
                            options: {
                                height: 400
                            },
                            theme: colorMode,
                            sourceType: "url",
                            noScrollbar: true,
                            tweetLimit: 4,
                            borderColor: colorMode === "dark" ? "#4a5568" : "#ddd",
                            url: url
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                        pos: "absolute",
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 1,
                        opacity: "0.5",
                        align: "center",
                        justify: "center",
                        h: "full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSize: "sm",
                                children: "Loading"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var InsightComponents_TwitterTimeline = (TwitterTimeline);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/hooks/dist/index.esm.js + 3 modules
var hooks_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/react/node_modules/@chakra-ui/hooks/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tooltip/dist/index.esm.js
var tooltip_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/tooltip/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var bi_index_esm = __webpack_require__("./node_modules/react-icons/bi/index.esm.js");
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("./node_modules/next/router.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/input/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/index.esm.js
var image_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/image/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-share/es/TwitterShareButton.js
var TwitterShareButton = __webpack_require__("./node_modules/react-share/es/TwitterShareButton.js");
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__("./node_modules/react-share/es/FacebookShareButton.js");
// EXTERNAL MODULE: ./node_modules/react-share/es/RedditShareButton.js
var RedditShareButton = __webpack_require__("./node_modules/react-share/es/RedditShareButton.js");
// EXTERNAL MODULE: ./node_modules/react-share/es/TelegramShareButton.js
var TelegramShareButton = __webpack_require__("./node_modules/react-share/es/TelegramShareButton.js");
// EXTERNAL MODULE: ./node_modules/react-share/es/WhatsappShareButton.js
var WhatsappShareButton = __webpack_require__("./node_modules/react-share/es/WhatsappShareButton.js");
// EXTERNAL MODULE: ./node_modules/react-share/es/LinkedinShareButton.js
var LinkedinShareButton = __webpack_require__("./node_modules/react-share/es/LinkedinShareButton.js");
// EXTERNAL MODULE: ./node_modules/react-share/es/EmailShareButton.js
var EmailShareButton = __webpack_require__("./node_modules/react-share/es/EmailShareButton.js");
;// CONCATENATED MODULE: ./src/components/Icons/twitterIconColor.tsx



const TwitterIconColor = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentcolor",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.7887 28C8.55374 28 5.53817 27.0591 3 25.4356C5.15499 25.5751 8.95807 25.2411 11.3236 22.9848C7.76508 22.8215 6.16026 20.0923 5.95094 18.926C6.25329 19.0426 7.6953 19.1826 8.50934 18.856C4.4159 17.8296 3.78793 14.2373 3.92748 13.141C4.695 13.6775 5.99745 13.8641 6.50913 13.8174C2.69479 11.0882 4.06703 6.98276 4.74151 6.09635C7.47882 9.88867 11.5812 12.0186 16.6564 12.137C16.5607 11.7174 16.5102 11.2804 16.5102 10.8316C16.5102 7.61092 19.1134 5 22.3247 5C24.0025 5 25.5144 5.71275 26.5757 6.85284C27.6969 6.59011 29.3843 5.97507 30.2092 5.4432C29.7934 6.93611 28.4989 8.18149 27.7159 8.64308C27.7224 8.65878 27.7095 8.62731 27.7159 8.64308C28.4037 8.53904 30.2648 8.18137 31 7.68256C30.6364 8.52125 29.264 9.91573 28.1377 10.6964C28.3473 19.9381 21.2765 28 11.7887 28Z",
            fill: "#47ACDF"
        })
    });
};
/* harmony default export */ var twitterIconColor = (TwitterIconColor);

;// CONCATENATED MODULE: ./src/components/Icons/facebookIconColor.tsx



const FacebookIconColor = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(icon_dist_index_esm/* Icon */.JO, {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentcolor",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "16",
                cy: "16",
                r: "14",
                fill: "url(#paint0_linear_5166_41589)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.2137 20.2816L21.8356 16.3301H17.9452V13.767C17.9452 12.6857 18.4877 11.6311 20.2302 11.6311H22V8.26699C22 8.26699 20.3945 8 18.8603 8C15.6548 8 13.5617 9.89294 13.5617 13.3184V16.3301H10V20.2816H13.5617V29.8345C14.2767 29.944 15.0082 30 15.7534 30C16.4986 30 17.2302 29.944 17.9452 29.8345V20.2816H21.2137Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_5166_41589",
                    x1: "16",
                    y1: "2",
                    x2: "16",
                    y2: "29.917",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#18ACFE"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: "#0163E0"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var facebookIconColor = (FacebookIconColor);

;// CONCATENATED MODULE: ./src/components/Icons/redditIconColor.tsx



const RedditIconColor = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(icon_dist_index_esm/* Icon */.JO, {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentcolor",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 2C8.27812 2 2 8.27813 2 16C2 23.7219 8.27812 30 16 30C23.7219 30 30 23.7219 30 16C30 8.27813 23.7219 2 16 2Z",
                fill: "#FC471E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.0193 8.90951C20.0066 8.98984 20 9.07226 20 9.15626C20 10.0043 20.6716 10.6918 21.5 10.6918C22.3284 10.6918 23 10.0043 23 9.15626C23 8.30819 22.3284 7.6207 21.5 7.6207C21.1309 7.6207 20.7929 7.7572 20.5315 7.98359L16.6362 7L15.2283 12.7651C13.3554 12.8913 11.671 13.4719 10.4003 14.3485C10.0395 13.9863 9.54524 13.7629 9 13.7629C7.89543 13.7629 7 14.6796 7 15.8103C7 16.5973 7.43366 17.2805 8.06967 17.6232C8.02372 17.8674 8 18.1166 8 18.3696C8 21.4792 11.5817 24 16 24C20.4183 24 24 21.4792 24 18.3696C24 18.1166 23.9763 17.8674 23.9303 17.6232C24.5663 17.2805 25 16.5973 25 15.8103C25 14.6796 24.1046 13.7629 23 13.7629C22.4548 13.7629 21.9605 13.9863 21.5997 14.3485C20.2153 13.3935 18.3399 12.7897 16.2647 12.7423L17.3638 8.24143L20.0193 8.90951ZM12.5 18.8815C13.3284 18.8815 14 18.194 14 17.3459C14 16.4978 13.3284 15.8103 12.5 15.8103C11.6716 15.8103 11 16.4978 11 17.3459C11 18.194 11.6716 18.8815 12.5 18.8815ZM19.5 18.8815C20.3284 18.8815 21 18.194 21 17.3459C21 16.4978 20.3284 15.8103 19.5 15.8103C18.6716 15.8103 18 16.4978 18 17.3459C18 18.194 18.6716 18.8815 19.5 18.8815ZM12.7773 20.503C12.5476 20.3462 12.2372 20.4097 12.084 20.6449C11.9308 20.8802 11.9929 21.198 12.2226 21.3548C13.3107 22.0973 14.6554 22.4686 16 22.4686C17.3446 22.4686 18.6893 22.0973 19.7773 21.3548C20.0071 21.198 20.0692 20.8802 19.916 20.6449C19.7628 20.4097 19.4524 20.3462 19.2226 20.503C18.3025 21.1309 17.1513 21.4449 16 21.4449C15.3173 21.4449 14.6345 21.3345 14 21.1137C13.5646 20.9621 13.1518 20.7585 12.7773 20.503Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var redditIconColor = (RedditIconColor);

;// CONCATENATED MODULE: ./src/components/Icons/telegramIconColor.tsx



const TelegramIconColor = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(icon_dist_index_esm/* Icon */.JO, {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentcolor",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "16",
                cy: "16",
                r: "14",
                fill: "url(#paint0_linear_5166_41608)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.9866 10.2088C23.1112 9.40332 22.3454 8.76755 21.6292 9.082L7.36482 15.3448C6.85123 15.5703 6.8888 16.3483 7.42147 16.5179L10.3631 17.4547C10.9246 17.6335 11.5325 17.541 12.0228 17.2023L18.655 12.6203C18.855 12.4821 19.073 12.7665 18.9021 12.9426L14.1281 17.8646C13.665 18.3421 13.7569 19.1512 14.314 19.5005L19.659 22.8523C20.2585 23.2282 21.0297 22.8506 21.1418 22.1261L22.9866 10.2088Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_5166_41608",
                    x1: "16",
                    y1: "2",
                    x2: "16",
                    y2: "30",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#37BBFE"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: "#007DBB"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var telegramIconColor = (TelegramIconColor);

;// CONCATENATED MODULE: ./src/components/Icons/whatsappIconColor.tsx



const WhatsappIconColor = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(icon_dist_index_esm/* Icon */.JO, {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentcolor",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16 31C23.732 31 30 24.732 30 17C30 9.26801 23.732 3 16 3C8.26801 3 2 9.26801 2 17C2 19.5109 2.661 21.8674 3.81847 23.905L2 31L9.31486 29.3038C11.3014 30.3854 13.5789 31 16 31ZM16 28.8462C22.5425 28.8462 27.8462 23.5425 27.8462 17C27.8462 10.4576 22.5425 5.15385 16 5.15385C9.45755 5.15385 4.15385 10.4576 4.15385 17C4.15385 19.5261 4.9445 21.8675 6.29184 23.7902L5.23077 27.7692L9.27993 26.7569C11.1894 28.0746 13.5046 28.8462 16 28.8462Z",
                fill: "#BFC8D0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28 16C28 22.6274 22.6274 28 16 28C13.4722 28 11.1269 27.2184 9.19266 25.8837L5.09091 26.9091L6.16576 22.8784C4.80092 20.9307 4 18.5589 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z",
                fill: "url(#paint0_linear_5166_41611)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 18.5109 2.661 20.8674 3.81847 22.905L2 30L9.31486 28.3038C11.3014 29.3854 13.5789 30 16 30ZM16 27.8462C22.5425 27.8462 27.8462 22.5425 27.8462 16C27.8462 9.45755 22.5425 4.15385 16 4.15385C9.45755 4.15385 4.15385 9.45755 4.15385 16C4.15385 18.5261 4.9445 20.8675 6.29184 22.7902L5.23077 26.7692L9.27993 25.7569C11.1894 27.0746 13.5046 27.8462 16 27.8462Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 9.50038C12.1672 8.8318 11.6565 8.89099 11.1407 8.89099C10.2188 8.89099 8.78125 9.99527 8.78125 12.0504C8.78125 13.7348 9.52345 15.5785 12.0244 18.3366C14.438 20.9984 17.6094 22.3753 20.2422 22.3284C22.875 22.2816 23.4167 20.0159 23.4167 19.2508C23.4167 18.9117 23.2062 18.7425 23.0613 18.6965C22.1641 18.2659 20.5093 17.4636 20.1328 17.3129C19.7563 17.1622 19.5597 17.366 19.4375 17.477C19.0961 17.8023 18.4193 18.7613 18.1875 18.977C17.9558 19.1926 17.6103 19.0835 17.4665 19.0019C16.9374 18.7896 15.5029 18.1516 14.3595 17.0431C12.9453 15.6723 12.8623 15.2006 12.5959 14.7808C12.3828 14.4449 12.5392 14.2389 12.6172 14.1488C12.9219 13.7973 13.3426 13.2545 13.5313 12.9848C13.7199 12.715 13.5702 12.3055 13.4803 12.0504C13.0938 10.9535 12.7663 10.0352 12.5 9.50038Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_5166_41611",
                    x1: "26.5",
                    y1: "7",
                    x2: "4",
                    y2: "28",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#5BD066"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "1",
                            stopColor: "#27B43E"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var whatsappIconColor = (WhatsappIconColor);

;// CONCATENATED MODULE: ./src/components/Icons/linkedinIconColor.tsx



const LinkedinIconColor = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(icon_dist_index_esm/* Icon */.JO, {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentcolor",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "2",
                y: "2",
                width: "28",
                height: "28",
                rx: "14",
                fill: "#1275B1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.6186 9.69215C12.6186 10.6267 11.8085 11.3843 10.8093 11.3843C9.81004 11.3843 9 10.6267 9 9.69215C9 8.7576 9.81004 8 10.8093 8C11.8085 8 12.6186 8.7576 12.6186 9.69215Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.24742 12.6281H12.3402V22H9.24742V12.6281Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.3196 12.6281H14.2268V22H17.3196C17.3196 22 17.3196 19.0496 17.3196 17.2049C17.3196 16.0976 17.6977 14.9855 19.2062 14.9855C20.911 14.9855 20.9008 16.4345 20.8928 17.5571C20.8824 19.0244 20.9072 20.5219 20.9072 22H24V17.0537C23.9738 13.8954 23.1508 12.4401 20.4433 12.4401C18.8354 12.4401 17.8387 13.1701 17.3196 13.8305V12.6281Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var linkedinIconColor = (LinkedinIconColor);

;// CONCATENATED MODULE: ./src/components/Icons/emailIconColor.tsx



const EmailIconColor = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(icon_dist_index_esm/* Icon */.JO, {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "currentcolor",
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
                fill: "#267CB5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.0012 18.1L25.5512 9.925C25.4012 9.825 25.2012 9.75 25.0012 9.75H7.00117C6.80117 9.75 6.60117 9.825 6.45117 9.925L16.0012 18.1Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.65 18.8506C16.275 19.1756 15.725 19.1756 15.35 18.8506L6 10.8756V21.2506C6 21.8006 6.45 22.2506 7 22.2506H25C25.55 22.2506 26 21.8006 26 21.2506V10.8506L16.65 18.8506Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var emailIconColor = (EmailIconColor);

// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__("./src/config/index.ts");
// EXTERNAL MODULE: ./src/components/Elements/index.ts + 6 modules
var Elements = __webpack_require__("./src/components/Elements/index.ts");
// EXTERNAL MODULE: ./src/utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__("./src/utils/googleAnalytics.ts");
// EXTERNAL MODULE: ./src/components/Elements/LinkElements/Link.tsx
var Link = __webpack_require__("./src/components/Elements/LinkElements/Link.tsx");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/CustomModals/ShareWikiModal.tsx
















const SHARING_OPTIONS = [
    {
        label: TwitterShareButton/* default */.Z,
        icon: twitterIconColor
    },
    {
        label: FacebookShareButton/* default */.Z,
        icon: facebookIconColor
    },
    {
        label: RedditShareButton/* default */.Z,
        icon: redditIconColor
    },
    {
        label: TelegramShareButton/* default */.Z,
        icon: telegramIconColor
    },
    {
        label: WhatsappShareButton/* default */.Z,
        icon: whatsappIconColor
    },
    {
        label: LinkedinShareButton/* default */.Z,
        icon: linkedinIconColor
    },
    {
        label: EmailShareButton/* default */.Z,
        icon: emailIconColor
    },
    {
        label: "lenster"
    }
];
const ShareWikiModal = (param)=>{
    let { onClose =()=>{} , isOpen =true  } = param;
    const router = (0,next_router.useRouter)();
    const url = "".concat(config/* default.publicDomain */.Z.publicDomain).concat(router.asPath);
    const { hasCopied , onCopy  } = (0,hooks_dist_index_esm/* useClipboard */.VP)(url);
    (0,react.useEffect)(()=>{
        (0,googleAnalytics/* logEvent */.K)({
            action: "OPEN_SHARE_WIKI_MODAL",
            label: router.asPath.replace("/wiki/", ""),
            category: "open_share_wiki_modal",
            value: 1
        });
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Elements/* Modal */.u_, {
        enableBottomCloseButton: false,
        isOpen: isOpen,
        onClose: onClose,
        title: "Share",
        isCentered: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(input_dist_index_esm/* InputGroup */.BZ, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                        p: 6,
                        whiteSpace: "nowrap",
                        value: url,
                        color: "#2D3748",
                        _dark: {
                            color: "#b1b2b5"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* InputRightAddon */.xW, {
                        p: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                            w: "50px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                textAlign: "center",
                                onClick: onCopy,
                                color: "brand.600",
                                cursor: "pointer",
                                children: hasCopied ? "Copied!" : "Copy"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                fontWeight: "bold",
                mt: "2rem",
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        color: "#1A202C",
                        fontSize: "sm",
                        _dark: {
                            color: "white"
                        },
                        children: "Or share via:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Wrap */.Eq, {
                        mt: "1rem",
                        spacing: "3",
                        children: SHARING_OPTIONS.map((item)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: typeof item.label !== "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(item.label, {
                                    url: url,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                        as: item.icon,
                                        fontSize: "38px"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "https://lenster.xyz/?text=Checkout%20this%20article%20on%20the%20World’s%20Largest%20Blockchain%20Encyclopedia,%20IQ.wiki&url=".concat(url),
                                    rel: "nofollow",
                                    target: "_blank",
                                    onClick: ()=>(0,googleAnalytics/* logEvent */.K)({
                                            action: "SHARING_WIKI_ON_LENS",
                                            label: url,
                                            category: "sharing_wiki_on_lens",
                                            value: 1
                                        }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                                        alt: "Lenster",
                                        src: "/images/icons/lenster.svg",
                                        h: "38px",
                                        w: "38px"
                                    })
                                })
                            });
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CustomModals_ShareWikiModal = (ShareWikiModal);

// EXTERNAL MODULE: ./src/hooks/useWeb3Token.ts
var useWeb3Token = __webpack_require__("./src/hooks/useWeb3Token.ts");
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__("./node_modules/wagmi/dist/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/index.esm.js + 1 modules
var toast_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/toast/dist/index.esm.js");
// EXTERNAL MODULE: ./src/services/profile/index.tsx + 1 modules
var profile = __webpack_require__("./src/services/profile/index.tsx");
// EXTERNAL MODULE: ./src/components/Notification/NotificationCard.tsx
var NotificationCard = __webpack_require__("./src/components/Notification/NotificationCard.tsx");
// EXTERNAL MODULE: ./src/services/profile/utils.ts
var utils = __webpack_require__("./src/services/profile/utils.ts");
// EXTERNAL MODULE: ./src/store/store.ts + 9 modules
var store = __webpack_require__("./src/store/store.ts");
// EXTERNAL MODULE: ./src/services/notification/index.ts + 1 modules
var notification = __webpack_require__("./src/services/notification/index.ts");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/CustomModals/SubscribeModal.tsx












const SIGN_TOKEN_MESSAGE = "To get notifications on changes to this wiki, authenticate your wallet to continue.";
const SUBSCRIBE_MESSAGE = "Subscribe to this wiki to get notifications on changes to this wiki.";
const UNSUBSCRIBE_MESSAGE = "You subscribed to this wiki already ! Click on the button below to stop getting notifications on changes to this wiki.";
const SubscribeModal = (param)=>{
    let { isOpen , onClose , wiki  } = param;
    const { token  } = (0,useWeb3Token/* useWeb3Token */.A)();
    const { address: userAddress  } = (0,dist/* useAccount */.mA)();
    const { profileData , setAccount , loading  } = (0,utils/* useUserProfileData */.Cf)(utils/* UserProfileFetchOptions.ONLY_EMAIL */.Ky.ONLY_EMAIL);
    const [isSubscribed, setIsSubscribed] = react.useState(null);
    const toast = (0,toast_dist_index_esm/* useToast */.pm)();
    const handleSubscriptionMutation = async ()=>{
        if (!userAddress) return;
        const email = profileData === null || profileData === void 0 ? void 0 : profileData.email;
        if (isSubscribed) {
            (0,NotificationCard/* RemoveWikiSubscriptionHandler */.Cp)(email, wiki === null || wiki === void 0 ? void 0 : wiki.id, userAddress, toast);
        } else if (wiki) {
            (0,NotificationCard/* SubscribeWikiHandler */.au)(email, wiki, userAddress, toast);
        }
        setIsSubscribed((p)=>!p);
    };
    (0,react.useEffect)(()=>{
        if (userAddress && token) {
            profile/* profileApiClient.setHeader */.$d.setHeader("authorization", token);
            setAccount(userAddress);
            const checkInitialSubscription = async ()=>{
                const { data  } = await store/* store.dispatch */.h.dispatch(notification/* getAllWikiSubscription.initiate */.K$.initiate(userAddress));
                const isWikiSubscribed = data ? data.some((w)=>w.auxiliaryId === wiki.id) : false;
                setIsSubscribed(isWikiSubscribed);
            };
            checkInitialSubscription();
        }
    }, [
        token,
        userAddress,
        wiki,
        toast,
        setAccount
    ]);
    const isLoading = token && (loading || isSubscribed === null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Elements/* Modal */.u_, {
        enableBottomCloseButton: false,
        isOpen: isOpen,
        title: isSubscribed ? "Subscribed !" : "Subscribe to wiki",
        onClose: onClose,
        isCentered: true,
        SecondaryButton: token && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
            variant: isSubscribed ? "outline" : "solid",
            onClick: handleSubscriptionMutation,
            children: isSubscribed ? "Unsubscribe" : "Subscribe"
        }),
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                color: "gray.500",
                children: "Checking Subscription Status..."
            }),
            !isLoading && !token && SIGN_TOKEN_MESSAGE,
            !isLoading && token && (isSubscribed ? UNSUBSCRIBE_MESSAGE : SUBSCRIBE_MESSAGE)
        ]
    });
};
/* harmony default export */ var CustomModals_SubscribeModal = (SubscribeModal);

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/WikiActionBar.tsx









const WikiActionBar = (param)=>{
    let { wiki  } = param;
    const { isOpen: isShareBoxOpen , onOpen: onShareBoxOpen , onClose: onShareBoxClose  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
    const { isOpen: isSubscribeBoxOpen , onOpen: onSubscribeBoxOpen , onClose: onSubscribeBoxClose  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
    const router = (0,next_router.useRouter)();
    const actionBarItems = [
        {
            label: "Read",
            icon: ri_index_esm/* RiBookOpenFill */.ZPS,
            isDisabled: !wiki,
            disabledTooltip: "Wiki not found",
            isActive: router.asPath === "/wiki/".concat(wiki === null || wiki === void 0 ? void 0 : wiki.id),
            handleClick: ()=>{}
        },
        {
            label: "Edit",
            icon: ri_index_esm/* RiEdit2Line */.enh,
            isDisabled: typeof (0,getUserAddressFromCache/* getUserAddressFromCache */.X)() !== "string",
            disabledTooltip: "Please login to edit",
            isActive: router.asPath === "/create-wiki?slug=".concat(wiki === null || wiki === void 0 ? void 0 : wiki.id),
            handleClick: ()=>{
                router.push("/create-wiki?slug=".concat(wiki === null || wiki === void 0 ? void 0 : wiki.id));
            }
        },
        {
            label: "History",
            icon: ri_index_esm/* RiHistoryLine */.WNt,
            isDisabled: false,
            handleClick: ()=>{
                router.push("/wiki/".concat(wiki === null || wiki === void 0 ? void 0 : wiki.id, "/history"));
            }
        },
        {
            label: "Notify",
            icon: ri_index_esm/* RiNotificationLine */.WqI,
            disabledTooltip: "Please login to subscribe",
            isDisabled: typeof (0,getUserAddressFromCache/* getUserAddressFromCache */.X)() !== "string",
            handleClick: onSubscribeBoxOpen
        },
        {
            label: "Share",
            icon: bi_index_esm/* BiShareAlt */.Sz6,
            isDisabled: !wiki,
            isActive: router.asPath === "",
            handleClick: onShareBoxOpen
        }
    ];
    const actionIconColor = (item)=>{
        if (item.isActive) return "brandLinkColor";
        if (item.isDisabled) return "wikiActionBtnDisabled";
        if (wiki === undefined) return "wikiActionBtnDisabled";
        return "unset";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
            borderRightWidth: {
                base: 0,
                md: "1px"
            },
            borderBottomWidth: {
                base: "1px",
                md: "0"
            },
            px: 6,
            py: 4,
            maxW: {
                base: "unset",
                md: "120px"
            },
            borderColor: "rankingListBorder",
            children: [
                isShareBoxOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModals_ShareWikiModal, {
                    isOpen: isShareBoxOpen,
                    onClose: onShareBoxClose
                }),
                isSubscribeBoxOpen && wiki && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModals_SubscribeModal, {
                    isOpen: isSubscribeBoxOpen,
                    onClose: onSubscribeBoxClose,
                    wiki: wiki
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                    direction: {
                        base: "row",
                        md: "column"
                    },
                    gap: {
                        base: 6,
                        sm: 8
                    },
                    position: "sticky",
                    top: "calc(50vh - 150px + 70px + 2px)",
                    transform: {
                        base: "unset",
                        md: "translateY(-50px)"
                    },
                    children: actionBarItems.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                            isDisabled: !item.isDisabled,
                            placement: "right",
                            label: item.disabledTooltip,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                cursor: item.isDisabled || wiki === undefined ? "not-allowed" : "pointer",
                                color: actionIconColor(item),
                                onClick: !item.isDisabled && wiki !== undefined ? item.handleClick : undefined,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                        fontSize: {
                                            base: "16px",
                                            sm: "20px"
                                        },
                                        as: item.icon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSize: {
                                            base: "12px",
                                            sm: "14px"
                                        },
                                        children: item.label
                                    })
                                ]
                            })
                        }, index))
                })
            ]
        })
    });
};
/* harmony default export */ var WikiPage_WikiActionBar = (WikiActionBar);

// EXTERNAL MODULE: ./src/services/token-stats/index.ts + 1 modules
var token_stats = __webpack_require__("./src/services/token-stats/index.ts");
;// CONCATENATED MODULE: ./src/services/token-stats/utils.ts


const remappingTokenIds = (token, cmcToken)=>{
    if (token !== cmcToken) {
        return {
            tokenName: token,
            cmcTokenName: cmcToken
        };
    }
    switch(token){
        case "polygon":
            return {
                tokenName: "matic-network",
                cmcTokenName: "polygon"
            };
        case "bnb":
            return {
                tokenName: "binancecoin",
                cmcTokenName: "bnb"
            };
        default:
            return {
                tokenName: token
            };
    }
};
const getTokenFromURI = (coingeckoUrl)=>coingeckoUrl.split("/").reverse().find((c)=>/\w+/.test(c));
const fetchTokenStats = async (coingeckoUrl, coinMarketCap)=>{
    if (!coingeckoUrl || !coinMarketCap) return undefined;
    const token = getTokenFromURI(coingeckoUrl);
    const cmcToken = getTokenFromURI(coinMarketCap);
    if (!token || !cmcToken) return undefined;
    const tokenDetails = remappingTokenIds(token, cmcToken);
    const { data  } = await store/* store.dispatch */.h.dispatch(token_stats/* getTokenStats.initiate */.dx.initiate(tokenDetails));
    return data;
};

// EXTERNAL MODULE: ./src/services/nft-stats/index.ts
var nft_stats = __webpack_require__("./src/services/nft-stats/index.ts");
;// CONCATENATED MODULE: ./src/services/nft-stats/utils.ts



const fetchNFTStats = async (coingeckoUrl)=>{
    if (!coingeckoUrl) return undefined;
    const nftID = getTokenFromURI(coingeckoUrl);
    if (!nftID) return undefined;
    const { data  } = await store/* store.dispatch */.h.dispatch(nft_stats/* getNFTStats.initiate */.Lu.initiate(nftID));
    return data;
};

// EXTERNAL MODULE: ./node_modules/react-sticky-box/dist/index.js
var react_sticky_box_dist = __webpack_require__("./node_modules/react-sticky-box/dist/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/table/dist/index.esm.js
var table_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/table/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tag/dist/index.esm.js
var tag_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/tag/dist/index.esm.js");
// EXTERNAL MODULE: ./src/utils/textUtils.ts
var textUtils = __webpack_require__("./src/utils/textUtils.ts");
// EXTERNAL MODULE: ./node_modules/react-icons/si/index.esm.js
var si_index_esm = __webpack_require__("./node_modules/react-icons/si/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-icons/go/index.esm.js
var go_index_esm = __webpack_require__("./node_modules/react-icons/go/index.esm.js");
// EXTERNAL MODULE: ./src/components/Elements/Avatar/DisplayAvatar.tsx
var DisplayAvatar = __webpack_require__("./src/components/Elements/Avatar/DisplayAvatar.tsx");
// EXTERNAL MODULE: ./src/hooks/useENSData.ts
var useENSData = __webpack_require__("./src/hooks/useENSData.ts");
// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
// EXTERNAL MODULE: ./src/utils/DataTransform/getUsername.ts
var getUsername = __webpack_require__("./src/utils/DataTransform/getUsername.ts");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/InsightComponents/WikiDetails.tsx













const WikiDetails = (param)=>{
    let { wikiTitle , categories , createdTime , ipfsHash , txHash , createdBy , imgSrc , views  } = param;
    var ref, ref1;
    const { title , tags , id: wikiId  } = wikiTitle;
    const [, username] = (0,useENSData/* useENSData */.L)((createdBy === null || createdBy === void 0 ? void 0 : createdBy.id) || "");
    const wikiViews = views !== undefined && views > 250 ? views : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        borderWidth: "1px",
        p: 4,
        borderRadius: 8,
        w: "full",
        borderColor: "rankingListBorder",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
            direction: {
                base: "column",
                lg: "row",
                xl: "column"
            },
            alignItems: "center",
            justifyContent: "space-between",
            spacing: 4,
            w: "full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                    bgColor: "wikiTitleBg",
                    as: "h3",
                    fontSize: "18px",
                    p: 3,
                    borderRadius: 6,
                    fontWeight: "600",
                    w: "100%",
                    textAlign: "center",
                    display: {
                        base: "none",
                        xl: "block"
                    },
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AspectRatio */.oM, {
                    mx: "auto",
                    w: "100%",
                    ml: "0 !important",
                    maxW: "400",
                    ratio: Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiImage/* WikiImage */.R, {
                        bgColor: "dimColor",
                        priority: true,
                        imageURL: imgSrc,
                        sizes: "(max-width: 400px) 100vw, 400px",
                        alt: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
                    maxW: {
                        base: "unset",
                        sm: "400px",
                        lg: "unset"
                    },
                    w: "100%",
                    spacing: 4,
                    mx: "auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm/* TableContainer */.xJ, {
                        w: "full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm/* Table */.iA, {
                            size: "sm",
                            variant: "simple",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(table_dist_index_esm/* Tbody */.p3, {
                                children: [
                                    categories.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(table_dist_index_esm.Tr, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                w: {
                                                    base: "unset",
                                                    sm: "10%",
                                                    xl: "unset"
                                                },
                                                pt: 1,
                                                pb: 3,
                                                children: "Categories"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                ml: "auto",
                                                flex: 1,
                                                pt: 1,
                                                pb: 3,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HStack */.Ug, {
                                                    flexWrap: "wrap",
                                                    justify: "start",
                                                    children: categories === null || categories === void 0 ? void 0 : categories.map((category, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                            href: "/categories/".concat(category.id),
                                                            color: "brandLinkColor",
                                                            children: category.title
                                                        }, i))
                                                })
                                            })
                                        ]
                                    }),
                                    tags.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(table_dist_index_esm.Tr, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                py: 1,
                                                children: "Tags"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                py: 1,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Wrap */.Eq, {
                                                    marginLeft: -2,
                                                    spacing: 1,
                                                    children: tags === null || tags === void 0 ? void 0 : tags.map((tag, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                            href: "/tags/".concat(tag.id),
                                                            py: 1,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* Tag */.Vp, {
                                                                whiteSpace: "nowrap",
                                                                children: tag.id
                                                            })
                                                        }, i))
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(table_dist_index_esm.Tr, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HStack */.Ug, {
                                                    spacing: 3,
                                                    py: "2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                        children: "IPFS"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                display: "flex",
                                                align: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                    gap: 1,
                                                    py: "2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(si_index_esm/* SiIpfs */.PaO, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                            target: "_blank",
                                                            href: "https://ipfs.everipedia.org/ipfs/".concat(ipfsHash),
                                                            color: "brandLinkColor",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                children: (0,textUtils/* shortenAccount */.p0)(ipfsHash || "")
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(table_dist_index_esm.Tr, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HStack */.Ug, {
                                                    spacing: 3,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                        children: "TX Hash"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(table_dist_index_esm.Td, {
                                                display: "flex",
                                                align: "center",
                                                gap: 3,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(go_index_esm/* GoLink */.NxY, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        target: "_blank",
                                                        href: "".concat(config/* default.blockExplorerUrl */.Z.blockExplorerUrl, "/tx/").concat(txHash),
                                                        color: "brandLinkColor",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                            children: (0,textUtils/* shortenAccount */.p0)(txHash || "")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(table_dist_index_esm.Tr, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HStack */.Ug, {
                                                    spacing: 3,
                                                    py: "2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                        children: "Events"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                display: "flex",
                                                align: "center",
                                                gap: 3,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HStack */.Ug, {
                                                    py: "2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: "/wiki/".concat(wikiId, "/events"),
                                                        color: "brandLinkColor",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                            children: "View timeline of events"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(table_dist_index_esm.Tr, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                whiteSpace: "nowrap",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    py: "2",
                                                    children: "Created"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    children: createdTime ? new Date(createdTime).toLocaleDateString("en-US", {
                                                        year: "numeric",
                                                        month: "long",
                                                        day: "numeric"
                                                    }) : "-"
                                                })
                                            })
                                        ]
                                    }),
                                    createdBy && /*#__PURE__*/ (0,jsx_runtime.jsxs)(table_dist_index_esm.Tr, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                whiteSpace: "nowrap",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    py: "2",
                                                    children: "Created By"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                    py: "2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAvatar/* default */.Z, {
                                                            alt: (ref = createdBy.profile) === null || ref === void 0 ? void 0 : ref.username,
                                                            address: createdBy.id,
                                                            avatarIPFS: (ref1 = createdBy.profile) === null || ref1 === void 0 ? void 0 : ref1.avatar,
                                                            size: 24
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                            href: "/account/".concat(createdBy.id),
                                                            color: "brandLinkColor",
                                                            prefetch: false,
                                                            children: (0,getUsername/* getUsername */.M)(createdBy, username)
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    wikiViews && /*#__PURE__*/ (0,jsx_runtime.jsxs)(table_dist_index_esm.Tr, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                whiteSpace: "nowrap",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    py: "2",
                                                    children: "Views"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm.Td, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    py: "2",
                                                    children: views === null || views === void 0 ? void 0 : views.toLocaleString("en-US")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/stat/dist/index.esm.js
var stat_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/stat/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiAccordion/AccordionWidget.tsx








const AccordionURLTemplate = (param)=>/*#__PURE__*/ {
    let { contentURL  } = param;
    return (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
        target: "_blank",
        color: "brandLinkColor",
        fontSize: "14px",
        href: contentURL,
        children: new URL(contentURL).hostname
    });
};
const AccordionAddressTemplate = (param)=>/*#__PURE__*/ {
    let { content , onCopy , hasCopied  } = param;
    return (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                target: "_blank",
                href: "https://etherscan.io/address/".concat(content),
                children: (0,textUtils/* shortenAccount */.p0)(content)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                onClick: onCopy,
                "aria-label": "copy address",
                minW: 3,
                icon: hasCopied ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiCheckboxCircleLine */.GH$, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiFileCopyLine */.qA2, {}),
                variant: "link"
            })
        ]
    });
};
const AccordionWidget = (param)=>{
    let { type , title , titleTag , content  } = param;
    const { hasCopied , onCopy  } = (0,hooks_dist_index_esm/* useClipboard */.VP)(content);
    const [, userENSDomain] = (0,useENSData/* useENSData */.L)(type === "account" ? content.id : "");
    const contentTemplate = ()=>{
        if (type === "url") {
            const contentURL = content;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionURLTemplate, {
                contentURL: contentURL
            });
        }
        if (type === "address") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionAddressTemplate, {
                onCopy: onCopy,
                hasCopied: hasCopied,
                content: content
            });
        }
        if (type === "account") {
            var ref, ref1;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAvatar/* default */.Z, {
                        alt: (ref = content.profile) === null || ref === void 0 ? void 0 : ref.username,
                        size: 16,
                        address: content.id,
                        avatarIPFS: (ref1 = content.profile) === null || ref1 === void 0 ? void 0 : ref1.avatar
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                        fontSize: "xs",
                        href: "/account/".concat(content.id),
                        color: "brandLinkColor",
                        children: (0,getUsername/* getUsername */.M)(content, userENSDomain)
                    })
                ]
            });
        }
        if (type === "explorers" && content instanceof Array) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                children: content.map((explorer, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                target: "_blank",
                                display: "block",
                                fontSize: "14px",
                                href: explorer,
                                children: new URL(explorer).hostname
                            }, explorer),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                minW: 3,
                                as: ri_index_esm/* RiShareBoxLine */.GtG
                            })
                        ]
                    }, i))
            });
        }
        if (type === "statistic") {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(stat_dist_index_esm/* Stat */.kN, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stat_dist_index_esm/* StatNumber */.Jf, {
                        float: "right",
                        fontSize: 14,
                        children: content.value
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(stat_dist_index_esm/* StatHelpText */.vh, {
                            float: "right",
                            m: 0,
                            children: [
                                content.changeDirection && /*#__PURE__*/ (0,jsx_runtime.jsx)(stat_dist_index_esm/* StatArrow */.uY, {
                                    type: content.changeDirection
                                }),
                                content.change
                            ]
                        })
                    })
                ]
            });
        }
        if (type === "market-statistics") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(stat_dist_index_esm/* Stat */.kN, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stat_dist_index_esm/* StatNumber */.Jf, {
                    float: "right",
                    fontSize: 14,
                    children: content.value
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            fontSize: "xs",
            children: content.toString()
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
        bgColor: "wikiCardItemBg",
        borderRadius: 8,
        justify: "space-between",
        align: "center",
        p: 4,
        spacing: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "linkColor",
                        children: title
                    }),
                    titleTag && /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* Tag */.Vp, {
                        size: "sm",
                        fontSize: 10,
                        variant: "solid",
                        children: titleTag
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                children: contentTemplate()
            })
        ]
    });
};
/* harmony default export */ var WikiAccordion_AccordionWidget = (AccordionWidget);

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/InsightComponents/ProfileStatistics.tsx





const ProfileStatistics = (props)=>{
    const { tokenStats  } = props;
    if (!tokenStats) return null;
    const getStatDirection = (stat)=>{
        if (stat === 0) return undefined;
        if (stat > 0) return "increase";
        return "decrease";
    };
    const statChange = (stat)=>{
        return "".concat(stat.toFixed(2), "%");
    };
    const statWithCommas = (stat)=>{
        return "$".concat(stat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    };
    const profileStatistics = [
        {
            type: "statistic",
            title: "Market Cap",
            content: {
                value: statWithCommas(tokenStats.market_cap),
                change: statChange(tokenStats.market_cap_percentage_change),
                changeDirection: getStatDirection(tokenStats.market_cap_percentage_change)
            }
        },
        {
            type: "statistic",
            title: "Diluted Market Cap",
            content: {
                value: statWithCommas(tokenStats.diluted_market_cap),
                change: statChange(tokenStats.diluted_market_cap_percentage_change),
                changeDirection: getStatDirection(tokenStats.diluted_market_cap_percentage_change)
            }
        },
        {
            type: "statistic",
            title: "Volume",
            titleTag: "24h",
            content: {
                value: statWithCommas(tokenStats.volume),
                change: statChange(tokenStats.volume_percentage_change),
                changeDirection: getStatDirection(tokenStats.volume_percentage_change)
            }
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
        w: "100%",
        spacing: 4,
        borderRadius: 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wiki_WikiAccordion, {
            withNoDarkBg: true,
            display: "flex",
            flexDir: "column",
            gap: 2,
            title: "Statistics",
            children: profileStatistics.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(WikiAccordion_AccordionWidget, {
                    ...item
                }, index))
        })
    });
};
/* harmony default export */ var InsightComponents_ProfileStatistics = (ProfileStatistics);

// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__("./node_modules/react-icons/fi/index.esm.js");
// EXTERNAL MODULE: ./src/data/WikiLinks.ts + 11 modules
var WikiLinks = __webpack_require__("./src/data/WikiLinks.ts");
;// CONCATENATED MODULE: ./src/utils/DataTransform/getFounderName.ts
const getFounderName = (text)=>{
    const names = text.split("-").map((slug)=>slug.charAt(0).toUpperCase() + slug.slice(1)).join(" ");
    return "".concat(names);
};

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/InsightComponents/ProfileSummary.tsx










const MAX_FOUNDERS_LIST = 3;
const parseLink = (link)=>link.startsWith("http") ? link : "https://".concat(link);
const ProfileListItem = (param)=>{
    let { title , children , lengthyArr  } = param;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
        bgColor: "wikiCardItemBg",
        borderRadius: 4,
        justify: "space-between",
        gap: "2",
        align: lengthyArr && (lengthyArr === null || lengthyArr === void 0 ? void 0 : lengthyArr.length) > MAX_FOUNDERS_LIST ? "initial" : "center",
        p: 4,
        flexDirection: lengthyArr && (lengthyArr === null || lengthyArr === void 0 ? void 0 : lengthyArr.length) > MAX_FOUNDERS_LIST ? "column" : "row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                fontSize: "14px",
                fontWeight: "bold",
                color: "linkColor",
                children: [
                    title,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                m: "0 !important",
                children: children
            })
        ]
    });
};
const ProfileSummary = (param)=>{
    let { wiki  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    const socialMetaData = wiki.metadata.filter((meta)=>build_module/* WikiPossibleSocialsList.includes */.Dl.includes(meta.id));
    if (!socialMetaData.length) return null;
    const socialLinksData = socialMetaData.filter((item)=>{
        var ref;
        return ((ref = WikiLinks/* LINK_OPTIONS.find */.c.find((option)=>option.id === item.id)) === null || ref === void 0 ? void 0 : ref.type) === WikiLinks/* LinkType.SOCIAL */.U.SOCIAL;
    });
    const explorerLinksData = socialMetaData.filter((item)=>{
        var ref;
        return ((ref = WikiLinks/* LINK_OPTIONS.find */.c.find((option)=>option.id === item.id)) === null || ref === void 0 ? void 0 : ref.type) === WikiLinks/* LinkType.EXPLORER */.U.EXPLORER;
    });
    const contractURL = (ref = socialMetaData.find((item)=>item.id === build_module/* CommonMetaIds.CONTRACT_URL */.wA.CONTRACT_URL)) === null || ref === void 0 ? void 0 : ref.value;
    const websiteLink = (ref1 = socialMetaData.find((item)=>item.id === build_module/* CommonMetaIds.WEBSITE */.wA.WEBSITE)) === null || ref1 === void 0 ? void 0 : ref1.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
        w: "100%",
        spacing: 4,
        borderRadius: 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wiki_WikiAccordion, {
            display: "flex",
            withNoDarkBg: true,
            flexDir: "column",
            gap: 2,
            title: "Profile Summary",
            children: [
                contractURL && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileListItem, {
                    title: "Contract",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                        isExternal: true,
                        rel: "noopener nofollow",
                        href: parseLink(contractURL),
                        color: "brandLinkColor",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                            align: "center",
                            gap: "2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "14px",
                                    children: (0,textUtils/* shortenText */.El)(contractURL, 20)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiExternalLink */.AlO, {
                                    color: "#ff5caa",
                                    fontSize: "18px"
                                })
                            ]
                        })
                    })
                }),
                websiteLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileListItem, {
                    title: "Official Website",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                        isExternal: true,
                        rel: "noopener nofollow",
                        href: parseLink(websiteLink),
                        color: "brandLinkColor",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                            align: "center",
                            gap: "2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "14px",
                                    children: (0,textUtils/* shortenText */.El)(websiteLink, 20)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiExternalLink */.AlO, {
                                    color: "#ff5caa",
                                    fontSize: "18px"
                                })
                            ]
                        })
                    })
                }),
                socialLinksData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileListItem, {
                    title: "Social Profiles",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Wrap */.Eq, {
                        spacing: 2,
                        children: socialLinksData.filter((item)=>{
                            var ref;
                            return ((ref = WikiLinks/* LINK_OPTIONS.find */.c.find((option)=>option.id === item.id)) === null || ref === void 0 ? void 0 : ref.type) === WikiLinks/* LinkType.SOCIAL */.U.SOCIAL;
                        }).map((social, i)=>{
                            var ref;
                            const Ico = (ref = WikiLinks/* LINK_OPTIONS.find */.c.find((li)=>li.id === social.id)) === null || ref === void 0 ? void 0 : ref.icon;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                target: "_blank",
                                href: parseLink(social.value),
                                rel: "noopener nofollow",
                                isExternal: true,
                                display: "flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                    color: "secondaryDark",
                                    _hover: {
                                        color: "brandLinkColor"
                                    },
                                    _dark: {
                                        color: "darkGrey",
                                        _hover: {
                                            color: "brandLinkColor"
                                        }
                                    },
                                    "aria-label": "Open ".concat(social.id),
                                    minW: 3,
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                        as: Ico
                                    }),
                                    variant: "link",
                                    fontSize: "20px"
                                }, i)
                            }, i);
                        })
                    })
                }),
                explorerLinksData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileListItem, {
                    title: "Explorers",
                    children: explorerLinksData.map((item)=>{
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                    color: "brandLinkColor",
                                    fontSize: "14px",
                                    href: parseLink(item.value),
                                    rel: "noopener nofollow",
                                    isExternal: true,
                                    _hover: {
                                        color: "linkColorHover",
                                        textDecoration: "underline"
                                    },
                                    children: (ref = WikiLinks/* LINK_OPTIONS.find */.c.find((option)=>option.id === item.id)) === null || ref === void 0 ? void 0 : ref.label
                                }, item.id),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                    color: "brandLinkColor",
                                    as: ri_index_esm/* RiExternalLinkLine */.uXP
                                })
                            ]
                        });
                    })
                }),
                ((ref2 = wiki.linkedWikis) === null || ref2 === void 0 ? void 0 : ref2.founders) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileListItem, {
                    title: "Founders",
                    lengthyArr: (ref3 = wiki.linkedWikis) === null || ref3 === void 0 ? void 0 : ref3.founders,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                        alignItems: "start",
                        flexWrap: "wrap",
                        gap: "1",
                        children: (ref4 = wiki.linkedWikis) === null || ref4 === void 0 ? void 0 : ref4.founders.map((founder, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                w: "max-content",
                                href: "/wiki/".concat(founder),
                                rel: "noopener nofollow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* Tag */.Vp, {
                                    fontSize: "10px",
                                    py: "1",
                                    children: getFounderName(founder)
                                })
                            }, i))
                    })
                }),
                ((ref5 = wiki.linkedWikis) === null || ref5 === void 0 ? void 0 : ref5.blockchains) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileListItem, {
                    title: "Blockchains",
                    lengthyArr: (ref6 = wiki.linkedWikis) === null || ref6 === void 0 ? void 0 : ref6.blockchains,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                        alignItems: "start",
                        flexWrap: "wrap",
                        gap: "1",
                        children: (ref7 = wiki.linkedWikis) === null || ref7 === void 0 ? void 0 : ref7.blockchains.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                w: "max-content",
                                href: "/wiki/".concat(item),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* Tag */.Vp, {
                                    py: "1",
                                    children: item
                                })
                            }, i))
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var InsightComponents_ProfileSummary = (ProfileSummary);

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/InsightComponents/CurrencyConverter.tsx





const CURRENCY_BOX_SIZE = 18;
const CurrencyBox = (param)=>{
    let { token , tokenImage , tokenSymbol , value , setValue  } = param;
    const tokenImageSrc = tokenImage ? tokenImage : "https://icons.iq.wiki/128/".concat(token, ".png");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
        zIndex: 2,
        m: "0px !important",
        justify: "space-between",
        align: "center",
        flex: "1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                align: "center",
                children: [
                    token ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        src: tokenImageSrc,
                        imgBoxSize: CURRENCY_BOX_SIZE,
                        alt: token,
                        borderRadius: "100px"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        src: "/images/logos/usd-logo.svg",
                        imgBoxSize: CURRENCY_BOX_SIZE,
                        alt: tokenSymbol
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        fontSize: "14px",
                        children: tokenSymbol
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                placeholder: "0",
                value: value,
                opacity: value ? "1" : "0.4",
                onChange: (e)=>setValue(e.target.value),
                textAlign: "right",
                fontSize: "14px",
                variant: "unstyled",
                w: "50%"
            })
        ]
    });
};
const CurrencyConverter = (param)=>{
    let { token , tokenStats , tokenImage  } = param;
    const conversionRate = tokenStats === null || tokenStats === void 0 ? void 0 : tokenStats.token_price_in_usd;
    const tokenSymbol = tokenStats.symbol;
    const [fromCurrency, setFromCurrency] = (0,react.useState)(0);
    const [toCurrency, setToCurrency] = (0,react.useState)(0);
    const [isTokenLeft, setIsTokenLeft] = (0,react.useState)(true);
    // function for updating the from currency
    const updateValues = (0,react.useCallback)((value, isEditedFrom)=>{
        // sanitize the input value
        let v = parseFloat(value);
        if (Number.isNaN(v)) v = 0;
        // update the state
        if (isEditedFrom) setFromCurrency(v);
        else setToCurrency(v);
        // calculate the comparing currency
        let c = 0;
        if (isEditedFrom) c = v * conversionRate;
        else c = v / conversionRate;
        // trim the value to 2 decimal places
        c = Math.round(c * 100) / 100;
        // update the state
        if (isEditedFrom) setToCurrency(c);
        else setFromCurrency(c);
    }, [
        conversionRate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
        w: "100%",
        spacing: 4,
        borderWidth: 1,
        borderRadius: 8,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
            w: "100%",
            bgColor: "wikiCardBg",
            p: 3,
            borderRadius: 8,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    style: {
                        userSelect: "none",
                        WebkitUserSelect: "none"
                    },
                    fontSize: "14px",
                    color: "linkColor",
                    children: "Converter"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    p: 2,
                    mt: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                        flexDirection: isTokenLeft ? "row" : "row-reverse",
                        px: 3,
                        borderRadius: 6,
                        justify: "space-between",
                        bgColor: "wikiCardItemBg",
                        position: "relative",
                        overflow: "hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                pos: "absolute",
                                top: 0,
                                right: 0,
                                w: "50%",
                                bgColor: "gray.50",
                                _dark: {
                                    bgColor: "gray.600"
                                },
                                h: "100%",
                                zIndex: 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyBox, {
                                token: token,
                                tokenSymbol: tokenSymbol,
                                tokenImage: tokenImage,
                                value: fromCurrency,
                                setValue: (e)=>updateValues(e, true)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                bgColor: "gray.100",
                                borderWidth: "1px",
                                color: "fadedText2",
                                "aria-label": "convert",
                                cursor: "pointer",
                                _dark: {
                                    bgColor: "gray.800"
                                },
                                variant: "ghost",
                                sx: {
                                    "&:hover, &:focus, &:active": {
                                        filter: "brightness(95%)"
                                    }
                                },
                                as: ri_index_esm/* RiArrowLeftRightLine */.ymM,
                                borderRadius: "50%",
                                p: 2,
                                zIndex: 2,
                                m: "2px 7px !important",
                                onClick: ()=>setIsTokenLeft(!isTokenLeft),
                                transform: "scale(0.8)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyBox, {
                                tokenSymbol: "USD",
                                value: toCurrency,
                                setValue: (e)=>updateValues(e, false)
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var InsightComponents_CurrencyConverter = (CurrencyConverter);

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/InsightComponents/WikiCommitMessage.tsx





const WikiCommitMessage = (param)=>{
    let { user , lastUpdated , commitMessage  } = param;
    const lastEdited = lastUpdated ? new Date(lastUpdated).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
    }) : "-";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
        w: "100%",
        spacing: 4,
        borderRadius: 8,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wiki_WikiAccordion, {
            display: "flex",
            withNoDarkBg: true,
            flexDir: "column",
            gap: 2,
            title: "Commit Info",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiAccordion_AccordionWidget, {
                    title: "Edited by:",
                    type: "account",
                    content: user
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiAccordion_AccordionWidget, {
                    title: "Edited in:",
                    type: "text",
                    content: lastEdited
                }),
                commitMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                    bgColor: "wikiCardItemBg",
                    borderRadius: 8,
                    align: "left",
                    p: 4,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontSize: "sm",
                            fontWeight: "bold",
                            color: "linkColor",
                            children: "Reason for edit:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontSize: "xs",
                            color: "linkColor",
                            children: commitMessage
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var InsightComponents_WikiCommitMessage = (WikiCommitMessage);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/skeleton/dist/index.esm.js + 1 modules
var skeleton_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/skeleton/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/index.esm.js
var form_control_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/form-control/dist/index.esm.js");
// EXTERNAL MODULE: ./src/services/nftlisting/index.ts
var nftlisting = __webpack_require__("./src/services/nftlisting/index.ts");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/InsightComponents/NFTImageFallBack.tsx



const PLACEHOLDER_IMAGE = "/images/defaults/broken-image.png";
const NFTImgFallback = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        flexDir: "column",
        alignItems: "center",
        justifyContent: "center",
        bg: "#2D3748",
        _light: {
            bg: "#F7FAFC"
        },
        h: "305px",
        gap: "2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                w: "30px",
                src: PLACEHOLDER_IMAGE
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontSize: "12px",
                children: "There seems to be a problem with the image"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/InsightComponents/NFTWidget.tsx







const NFTWidget = (param)=>{
    let { categories , metaData  } = param;
    var ref;
    const isNFTWiki = categories.find((item)=>{
        return item.id === "nfts";
    });
    const [currentNFTImage, setCurrentNTFImage] = (0,react.useState)("");
    const [currentNFTHash, setCurrentNFTHash] = (0,react.useState)(1);
    const [currentNFTHashDisplay, setCurrentNFTHashDisplay] = (0,react.useState)(1);
    const [showNFTFetchError, setShowNFTFetchError] = (0,react.useState)(false);
    const [isLoading, setIsLoading] = (0,react.useState)(true);
    const contractData = (ref = metaData.find((item)=>item.id === "contract_url")) === null || ref === void 0 ? void 0 : ref.value;
    const contractID = contractData === null || contractData === void 0 ? void 0 : contractData.split("/").pop();
    const fetchNFT = (0,react.useCallback)(async ()=>{
        setIsLoading(true);
        if (contractID && isNFTWiki && currentNFTHash) {
            const { data  } = await store/* store.dispatch */.h.dispatch(nftlisting/* nftListing.initiate */.Ub.initiate({
                nftContractID: contractID || "",
                nftHash: currentNFTHash
            }));
            const nftImgURL = data === null || data === void 0 ? void 0 : data.media[0].gateway;
            if (data === null || data === void 0 ? void 0 : data.error) {
                setShowNFTFetchError(true);
                setIsLoading(false);
            } else setShowNFTFetchError(false);
            setCurrentNTFImage(nftImgURL || "");
            setCurrentNFTHashDisplay(currentNFTHash);
            setIsLoading(false);
        }
    }, [
        contractID,
        currentNFTHash,
        isNFTWiki
    ]);
    // getting associated nft image
    (0,react.useEffect)(()=>{
        if (contractID && isNFTWiki) {
            fetchNFT();
        }
    }, [
        contractID,
        fetchNFT,
        isNFTWiki
    ]);
    if (isNFTWiki && contractData) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wiki_WikiAccordion, {
            display: "flex",
            withNoDarkBg: true,
            flexDir: "column",
            gap: 2,
            title: "Search NFT Collection",
            children: [
                isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            height: "305px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                            justifyContent: "center",
                            my: "4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                w: "70px",
                                height: "20px",
                                borderRadius: "30px"
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    flexDirection: "column",
                    bg: "#f5f5f5",
                    _dark: {
                        bg: "transparent"
                    },
                    w: "100%",
                    gap: "4",
                    borderRadius: 8,
                    children: [
                        !showNFTFetchError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                            src: currentNFTImage,
                            height: "auto",
                            onLoad: ()=>setIsLoading(false),
                            maxHeight: "500px"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NFTImgFallback, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                                children: [
                                    "#",
                                    currentNFTHashDisplay
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    borderRadius: "8px",
                    flexDir: "row",
                    alignItems: "center",
                    bg: "white",
                    _dark: {
                        bg: "#2d3748"
                    },
                    p: "2",
                    gap: "2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(form_control_dist_index_esm/* FormControl */.NI, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                                boxSizing: "border-box",
                                _focus: {
                                    border: "1px solid #FF5CAA"
                                },
                                p: "1",
                                border: "none",
                                type: "number",
                                placeholder: "Input NFT ID",
                                onChange: (e)=>{
                                    const value = Number(e.target.value);
                                    if (!Number.isNaN(value)) {
                                        setCurrentNFTHash(value);
                                    }
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            cursor: "pointer",
                            as: "a",
                            target: "_blank",
                            size: "md",
                            variant: "solid",
                            disabled: !currentNFTHash,
                            onClick: ()=>{
                                fetchNFT();
                            },
                            children: "Search"
                        })
                    ]
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ var InsightComponents_NFTWidget = (NFTWidget);

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/InsightComponents/NFTStatistics.tsx





const NFTStatistics = (props)=>{
    const { nftStats  } = props;
    if (!nftStats) return null;
    const getStatDirection = (stat)=>{
        if (stat === 0) return undefined;
        if (stat > 0) return "increase";
        return "decrease";
    };
    const statChange = (stat)=>{
        return "".concat(stat.toFixed(2), "%");
    };
    const statWithCommas = (stat, type)=>{
        const transformStat = "".concat(stat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        const statValue = type === "currency" ? "$".concat(transformStat) : transformStat;
        return statValue;
    };
    const NFTStatisticsData = [
        {
            type: "market-statistics",
            title: "Floor Price",
            content: {
                value: statWithCommas(nftStats.floor_price.usd, "currency")
            }
        },
        {
            type: "market-statistics",
            title: "Market Cap",
            content: {
                value: statWithCommas(nftStats.market_cap.usd, "currency")
            }
        },
        {
            type: "market-statistics",
            title: "Volume",
            titleTag: "24h",
            content: {
                value: statWithCommas(nftStats.volume_24h.usd, "currency")
            }
        },
        {
            type: "statistic",
            title: "Owners",
            content: {
                value: statWithCommas(nftStats.number_of_unique_addresses),
                change: statChange(nftStats.number_of_unique_addresses_24h_percentage_change),
                changeDirection: getStatDirection(nftStats.number_of_unique_addresses_24h_percentage_change)
            }
        },
        {
            type: "market-statistics",
            title: "Total Assets",
            content: {
                value: statWithCommas(nftStats.total_supply)
            }
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
        w: "100%",
        spacing: 4,
        borderRadius: 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wiki_WikiAccordion, {
            withNoDarkBg: true,
            display: "flex",
            flexDir: "column",
            gap: 2,
            title: "NFT Market Statistics",
            children: NFTStatisticsData.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(WikiAccordion_AccordionWidget, {
                    ...item
                }, index))
        })
    });
};
/* harmony default export */ var InsightComponents_NFTStatistics = (NFTStatistics);

// EXTERNAL MODULE: ./node_modules/react-icons/vsc/index.esm.js
var vsc_index_esm = __webpack_require__("./node_modules/react-icons/vsc/index.esm.js");
// EXTERNAL MODULE: ./src/services/admin/index.ts + 1 modules
var admin = __webpack_require__("./src/services/admin/index.ts");
;// CONCATENATED MODULE: ./src/types/admin.ts
var ContentFeedbackType;
(function(ContentFeedbackType) {
    ContentFeedbackType["positive"] = "POSITIVE";
    ContentFeedbackType["negative"] = "NEGATIVE";
    ContentFeedbackType["neutral"] = "NEUTRAL";
})(ContentFeedbackType || (ContentFeedbackType = {}));

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/InsightComponents/ContentFeedback.tsx








const ContentFeedback = (param)=>{
    let { choice , contentId , userId  } = param;
    const [feedbackVal, setFeedbackVal] = (0,react.useState)(choice);
    const [contentFeedback] = (0,admin/* useContentFeedbackMutation */.hu)();
    const sendFeedback = async (feedback)=>{
        setFeedbackVal(false);
        await contentFeedback({
            contentId,
            userId,
            feedback
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
        w: "100%",
        spacing: 4,
        borderRadius: 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wiki_WikiAccordion, {
            display: "flex",
            withNoDarkBg: true,
            flexDir: "column",
            gap: 2,
            title: "Feedback",
            defaultOpen: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
                bgColor: "wikiCardItemBg",
                borderRadius: 4,
                gap: "2",
                p: 3,
                children: feedbackVal ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    w: "full",
                    alignItems: "start",
                    px: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontSize: "14px",
                            children: "Did you find this article interesting?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                            mt: "3",
                            w: "full",
                            justifyContent: "space-between",
                            fontSize: "14px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    w: "48%",
                                    rounded: "lg",
                                    fontSize: "16px",
                                    size: "md",
                                    fontWeight: "normal",
                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiThumbsUp */.fmn, {
                                        fontSize: "20px"
                                    }),
                                    onClick: ()=>sendFeedback(ContentFeedbackType.positive),
                                    children: "Yes"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    w: "48%",
                                    rounded: "lg",
                                    fontSize: "16px",
                                    size: "md",
                                    fontWeight: "normal",
                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi_index_esm/* FiThumbsDown */.oLd, {
                                        fontSize: "20px"
                                    }),
                                    onClick: ()=>sendFeedback(ContentFeedbackType.negative),
                                    children: "No"
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    alignItems: "center",
                    gap: 1,
                    w: "full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontWeight: "light",
                            fontSize: "14px",
                            children: "Thank you for the honest Feedback!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(vsc_index_esm/* VscSmiley */.wYQ, {
                            color: "#ff1a88"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var InsightComponents_ContentFeedback = (ContentFeedback);

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/WikiInsights.tsx




















const WikiInsights = (param)=>{
    let { wiki , ipfs , dateTime  } = param;
    var ref, ref1, ref2, ref3;
    const stickyRef = (0,react_sticky_box_dist/* useStickyBox */.P)({
        offsetTop: 100,
        offsetBottom: 20
    });
    const coingeckoLink = (ref = wiki.metadata.find((meta)=>meta.id === build_module/* CommonMetaIds.COINGECKO_PROFILE */.wA.COINGECKO_PROFILE)) === null || ref === void 0 ? void 0 : ref.value;
    const coinmarketcapLink = (ref1 = wiki.metadata.find((meta)=>meta.id === build_module/* CommonMetaIds.COIN_MARKET_CAP */.wA.COIN_MARKET_CAP)) === null || ref1 === void 0 ? void 0 : ref1.value;
    const twitterLink = (ref2 = wiki.metadata.find((meta)=>meta.id === build_module/* CommonMetaIds.TWITTER_PROFILE */.wA.TWITTER_PROFILE)) === null || ref2 === void 0 ? void 0 : ref2.value;
    const commitMessage = (ref3 = wiki.metadata.find((meta)=>meta.id === build_module/* EditSpecificMetaIds.COMMIT_MESSAGE */.F6.COMMIT_MESSAGE)) === null || ref3 === void 0 ? void 0 : ref3.value;
    const wikiIsNFT = /https:\/\/(www.)?coingecko.com\/en\/nft\/(.+)/.test(coingeckoLink || "");
    const [tokenStats, setTokenStats] = (0,react.useState)();
    const [nftStats, setNftStats] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        if (!wikiIsNFT) {
            const fetchTokenData = async ()=>{
                await fetchTokenStats(coingeckoLink, coinmarketcapLink).then((res)=>{
                    setTokenStats(res);
                });
            };
            fetchTokenData();
        }
        if (wikiIsNFT) {
            const fetchNFTData = async ()=>{
                await fetchNFTStats(coingeckoLink).then((res)=>{
                    setNftStats(res);
                });
            };
            fetchNFTData();
        }
    }, [
        coingeckoLink,
        wikiIsNFT
    ]);
    const userAddress = (0,getUserAddressFromCache/* getUserAddressFromCache */.X)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
        borderLeftWidth: {
            base: 0,
            xl: "1px"
        },
        p: {
            base: 0,
            md: 2,
            xl: 4
        },
        pr: {
            md: 11,
            xl: 4
        },
        pt: {
            xl: "24",
            md: "8",
            base: "10"
        },
        borderColor: "rankingListBorder",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
            as: "aside",
            ref: stickyRef,
            w: "100%",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                w: {
                    base: "90%",
                    md: "100%",
                    xl: "clamp(300px, 25vw, 430px)"
                },
                mx: {
                    base: "auto",
                    xl: 0
                },
                px: {
                    base: "0",
                    md: "4",
                    xl: "0"
                },
                spacing: 6,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiDetails, {
                        wikiTitle: wiki,
                        categories: wiki.categories,
                        createdTime: wiki === null || wiki === void 0 ? void 0 : wiki.created,
                        ipfsHash: ipfs || wiki.ipfs,
                        txHash: wiki.transactionHash,
                        createdBy: wiki.author,
                        imgSrc: (0,getWikiImageUrl/* getWikiImageUrl */.A)(wiki.images),
                        views: wiki.views
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightComponents_ProfileSummary, {
                        wiki: wiki
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        w: "full",
                        display: {
                            base: "none",
                            xl: "block"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightComponents_ContentFeedback, {
                            choice: true,
                            contentId: wiki.id,
                            userId: userAddress
                        })
                    }),
                    !!coingeckoLink && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightComponents_ProfileStatistics, {
                                tokenStats: tokenStats
                            }),
                            wikiIsNFT && /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightComponents_NFTStatistics, {
                                nftStats: nftStats
                            }),
                            tokenStats && /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightComponents_CurrencyConverter, {
                                tokenImage: tokenStats.token_image_url,
                                token: getTokenFromURI(coingeckoLink),
                                tokenStats: tokenStats
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightComponents_NFTWidget, {
                        categories: wiki.categories,
                        metaData: wiki.metadata
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightComponents_WikiCommitMessage, {
                        commitMessage: commitMessage,
                        user: wiki.user,
                        lastUpdated: wiki.updated || dateTime
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                        w: "100%",
                        display: {
                            base: "none",
                            xl: "block",
                            md: "none"
                        },
                        gap: 6,
                        children: [
                            !!twitterLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightComponents_TwitterTimeline, {
                                url: twitterLink
                            }),
                            wiki.categories.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedWikis, {
                                wikiId: wiki.id,
                                category: wiki.categories[0].id
                            }),
                            wiki.media && wiki.media.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedMedia, {
                                media: wiki.media
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var WikiPage_WikiInsights = (WikiInsights);

// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 114 modules
var react_markdown = __webpack_require__("./node_modules/react-markdown/lib/react-markdown.js");
// EXTERNAL MODULE: ./node_modules/remark-gfm/index.js + 28 modules
var remark_gfm = __webpack_require__("./node_modules/remark-gfm/index.js");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/CustomRenderers/customHeadingRender.tsx


const addToTOC = (param)=>{
    let { children , ...props } = param;
    var ref;
    const level = Number((ref = props.node.tagName.match(/h(\d)/)) === null || ref === void 0 ? void 0 : ref.slice(1));
    if (level && children && typeof children[0] === "string") {
        const id = "".concat(children[0].toLowerCase().replace(/[^a-z0-9]+/g, "-"), "-").concat(store/* store.getState */.h.getState().toc.length);
        store/* store.dispatch */.h.dispatch({
            type: "toc/addToc",
            payload: {
                level,
                id,
                title: children[0]
            }
        });
        return /*#__PURE__*/ react.createElement(props.node.tagName, {
            id
        }, children);
    }
    return /*#__PURE__*/ react.createElement(props.node.tagName, props, children);
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/popover/dist/index.esm.js + 1 modules
var popover_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/popover/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/CustomRenderers/LinkRenderers/CiteMarksRender.tsx
/* eslint-disable react-hooks/rules-of-hooks */ 



const CiteMarksRender = (param)=>{
    let { text , href , referencesString  } = param;
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const id = href === null || href === void 0 ? void 0 : href.split("#cite-id-")[1];
    const [count, setCount] = (0,react.useState)(0);
    const [isActive, setIsActive] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const onHashChanged = ()=>{
            setIsActive(window.location.hash === "#cite-mark-".concat(id, "-").concat(count));
        };
        window.addEventListener("hashchange", onHashChanged);
        return ()=>{
            window.removeEventListener("hashchange", onHashChanged);
        };
    }, [
        count,
        id
    ]);
    (0,react.useEffect)(()=>{
        store/* store.dispatch */.h.dispatch({
            type: "citeMarks/incCiteCount",
            payload: id
        });
        const storedCount = store/* store.getState */.h.getState().citeMarks[id || ""];
        setCount(storedCount);
    }, [
        id
    ]);
    const references = referencesString ? JSON.parse(referencesString) : [];
    const ref = references.find((r)=>r.id === id);
    const citeOpenTimeout = (0,react.useRef)(null);
    const openCitePopup = (0,react.useCallback)(()=>{
        citeOpenTimeout.current = setTimeout(()=>setIsOpen(true), 100);
    }, []);
    const closeCitePopup = (0,react.useCallback)(()=>{
        if (citeOpenTimeout.current) {
            clearTimeout(citeOpenTimeout.current);
        }
        setIsOpen(false);
    }, []);
    const citeLink = /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
        onMouseLeave: closeCitePopup,
        onMouseEnter: openCitePopup,
        onFocus: ()=>{},
        onBlur: ()=>{},
        href: href,
        borderRadius: "100px",
        color: "brandLinkColor",
        _focus: {
            outline: "none",
            textDecoration: "underline"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            as: "sup",
            id: "cite-mark-".concat(id, "-").concat(count),
            scrollMarginTop: "50vh",
            bgColor: isActive ? "#e160a12a" : "transparent",
            boxShadow: isActive ? "0 0 0 3px #e160a12a" : "none",
            borderRadius: 2,
            zIndex: -1,
            children: text
        })
    });
    if (!isOpen) return citeLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* Popover */.J2, {
        isOpen: true,
        returnFocusOnClose: false,
        autoFocus: false,
        "aria-label": "Wiki preview",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverTrigger */.xo, {
                children: citeLink
            }),
            ref && /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* PopoverContent */.yk, {
                boxShadow: "rgb(4 17 29 / 25%) 0px 0px 8px 0px",
                _focus: {
                    outline: "none"
                },
                mx: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverArrow */.QH, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* PopoverBody */.b, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                flexWrap: "wrap",
                                gap: 1,
                                p: 1,
                                mb: 1,
                                borderBottomWidth: ref.description.trim().length ? "1px" : 0,
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* Tag */.Vp, {
                                        colorScheme: "blue",
                                        size: "sm",
                                        fontWeight: "medium",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                            color: "#304262 !important",
                                            _dark: {
                                                color: "#9dcbf0 !important"
                                            },
                                            fontSize: "sm",
                                            p: "0 !important",
                                            href: ref.url,
                                            children: new URL(ref.url).hostname
                                        })
                                    }),
                                    ref.timestamp && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        m: "2px !important",
                                        opacity: 0.6,
                                        fontSize: "sm",
                                        children: new Date(ref.timestamp).toLocaleDateString("en-US", {
                                            month: "short",
                                            day: "numeric",
                                            year: "numeric"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                m: "2px !important",
                                fontSize: "sm",
                                children: ref.description
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LinkRenderers_CiteMarksRender = (CiteMarksRender);

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/CustomRenderers/LinkRenderers/WikiLinkRender.tsx








const WikiLinkPreviewSkeleton = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverHeader */.Yt, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                    justify: "center",
                    opacity: 0.8,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            boxSize: 5
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            h: 5,
                            w: 20
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverBody */.b, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                    align: "start",
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            boxSize: 20,
                            flexShrink: 0
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                            w: "full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                    h: 5,
                                    w: "full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                    h: 5,
                                    w: "full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                    h: 5,
                                    w: "full"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverFooter */.DT, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                    spacing: 2,
                    align: "center",
                    flexWrap: "wrap",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            h: 5,
                            w: 10
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            h: 5,
                            w: 10
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            h: 5,
                            w: 10
                        })
                    ]
                })
            })
        ]
    });
const WikiLinkPreview = (param)=>{
    let { wikiId  } = param;
    var ref, ref1;
    const { data: wiki , isLoading  } = (0,wikis/* useGetWikiPreviewQuery */.w3)(wikiId);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* PopoverContent */.yk, {
        boxShadow: "rgb(4 17 29 / 25%) 0px 0px 8px 0px",
        _focus: {
            outline: "none"
        },
        mx: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverArrow */.QH, {}),
            !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverHeader */.Yt, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                            justify: "center",
                            opacity: 0.8,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                    as: ri_index_esm/* RiLightbulbLine */.dc7
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "15px",
                                    children: wiki === null || wiki === void 0 ? void 0 : wiki.title
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverBody */.b, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                            align: "start",
                            spacing: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiImage/* WikiImage */.R, {
                                    mt: 1,
                                    borderRadius: 2,
                                    overflow: "hidden",
                                    flexShrink: 0,
                                    w: "100px",
                                    h: "100px",
                                    imageURL: (0,getWikiImageUrl/* getWikiImageUrl */.A)(wiki === null || wiki === void 0 ? void 0 : wiki.images),
                                    alt: (wiki === null || wiki === void 0 ? void 0 : wiki.title) || "wiki"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "14px",
                                    children: wiki && (0,getWikiSummary/* getWikiSummary */.L)(wiki)
                                })
                            ]
                        })
                    }),
                    (wiki === null || wiki === void 0 ? void 0 : (ref = wiki.tags) === null || ref === void 0 ? void 0 : ref.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverFooter */.DT, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                            gap: "1",
                            align: "center",
                            flexWrap: "wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(tag_dist_index_esm/* Tag */.Vp, {
                                    variant: "outline",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* TagLeftIcon */.AD, {
                                            mr: 1,
                                            boxSize: "12px",
                                            as: ri_index_esm/* RiPriceTagLine */.ckV
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* TagLabel */.Sn, {
                                            ml: 0,
                                            fontSize: "12px",
                                            children: "TAGS"
                                        })
                                    ]
                                }),
                                wiki === null || wiki === void 0 ? void 0 : (ref1 = wiki.tags) === null || ref1 === void 0 ? void 0 : ref1.map((tag, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* Tag */.Vp, {
                                        bgColor: "hsl(".concat(Math.floor(i * 0.5 * 360), ", 40%, 80%)"),
                                        color: "black",
                                        children: tag.id
                                    }, i))
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiLinkPreviewSkeleton, {})
        ]
    });
};
const WikiLinkRender = (param)=>{
    let { href , text , slug  } = param;
    const [isOpen, setIsOpen] = react.useState(false);
    const linkRef = react.useRef(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* Popover */.J2, {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        returnFocusOnClose: false,
        "aria-label": "Wiki preview",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverTrigger */.xo, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    ref: linkRef,
                    onMouseOver: ()=>setIsOpen(true),
                    onMouseOut: ()=>setIsOpen(false),
                    onFocus: ()=>{},
                    onBlur: ()=>{},
                    href: href,
                    color: "brandLinkColor",
                    children: text
                })
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiLinkPreview, {
                wikiId: slug
            })
        ]
    });
};
/* harmony default export */ var LinkRenderers_WikiLinkRender = (WikiLinkRender);

// EXTERNAL MODULE: ./node_modules/react-lite-youtube-embed/dist/index.es.jsx
var index_es = __webpack_require__("./node_modules/react-lite-youtube-embed/dist/index.es.jsx");
// EXTERNAL MODULE: ./node_modules/react-lite-youtube-embed/dist/LiteYouTubeEmbed.css
var LiteYouTubeEmbed = __webpack_require__("./node_modules/react-lite-youtube-embed/dist/LiteYouTubeEmbed.css");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/CustomRenderers/LinkRenderers/WidgetLinkRender.tsx




const WidgetLinkRender = (param)=>{
    let { text , href  } = param;
    const [iframeLoading, setIframeLoading] = (0,react.useState)(true);
    const [isInView, setIsInView] = (0,react.useState)(false);
    const widgetRef = react.useRef(null);
    (0,react.useEffect)(()=>{
        const observer = new IntersectionObserver((param)=>{
            let [entry] = param;
            if (entry.isIntersecting) setIsInView(true);
        }, {
            root: null,
            rootMargin: "0px",
            threshold: 0.1
        });
        observer.observe(widgetRef.current);
        return ()=>observer.disconnect();
    }, []);
    const iframeLoadHandler = ()=>{
        setIframeLoading(false);
    };
    const renderWidget = (src, title, type)=>{
        if (type === "youtube") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                ref: widgetRef,
                className: "embed-widget-iframe embed-widget-iframe__loaded",
                children: isInView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                    id: src,
                    title: ""
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            ref: widgetRef,
            className: iframeLoading ? "embed-widget-iframe" : "embed-widget-iframe embed-widget-iframe__loaded",
            children: isInView ? /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                className: type === "dune" ? "embed-widget-iframe-dune-bg" : "",
                onLoad: iframeLoadHandler,
                loading: "lazy",
                title: title,
                src: src
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
        });
    };
    switch(text){
        case "YOUTUBE@VID":
            return renderWidget(href, "youtube video", "youtube");
        case "DUNE@EMBED":
            return renderWidget("https://dune.com/embeds/".concat(href), "Dune Embed", "dune");
        default:
            return null;
    }
};
/* harmony default export */ var LinkRenderers_WidgetLinkRender = (WidgetLinkRender);

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/CustomRenderers/customLinkRender.tsx








const customLinkRenderer = (param)=>{
    let { children , referencesString , ...props } = param;
    var ref;
    const linkHref = props.href;
    const linkText = typeof children[0] === "string" ? children[0] : "";
    const wikiSlug = (ref = linkHref === null || linkHref === void 0 ? void 0 : linkHref.match(new RegExp("".concat(config/* default.publicDomain */.Z.publicDomain, "/wiki/(.*)")))) === null || ref === void 0 ? void 0 : ref[1];
    const isWikiLink = linkText.length > 0 && wikiSlug;
    if (isWikiLink) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkRenderers_WikiLinkRender, {
            href: linkHref,
            text: linkText,
            slug: wikiSlug
        });
    }
    const isCiteIdPresent = linkHref === null || linkHref === void 0 ? void 0 : linkHref.match(/#cite-id-(.*)/);
    if (isCiteIdPresent) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkRenderers_CiteMarksRender, {
            referencesString: referencesString,
            href: linkHref,
            text: linkText
        });
    }
    const isWidgetLink = linkText && linkHref && build_module/* whiteListedLinkNames.includes */.Kp.includes(linkText) && !(0,textUtils/* isValidUrl */.jv)(linkHref);
    if (isWidgetLink) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkRenderers_WidgetLinkRender, {
            text: linkText,
            href: linkHref
        });
    }
    return /*#__PURE__*/ react.createElement(props.node.tagName, props, children);
};

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/CustomRenderers/customImageRender.tsx



const customImageRender = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
        h: "300px",
        my: 2,
        objectFit: "contain",
        src: props.src || "",
        alt: "wiki"
    });
};

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/CustomRenderers/customTableRender.tsx


const customTableRenderer = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "table-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
            ...props,
            children: children
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 52 modules
var modal_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/modal/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/textarea/dist/index.esm.js
var textarea_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/textarea/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/WikiFlaggingSystem.tsx






const FlaggingSystemModal = (param)=>{
    let { id , isOpen , onClose  } = param;
    const toast = (0,toast_dist_index_esm/* useToast */.pm)();
    const [flagContent, setFlagContent] = (0,react.useState)("");
    const [postFlagWiki] = (0,wikis/* usePostFlagWikiMutation */.I0)();
    const postFlagHandler = async (e)=>{
        e.preventDefault();
        const postFlagWikiData = await postFlagWiki({
            report: flagContent,
            wikiId: id,
            userId: (0,getUserAddressFromCache/* getUserAddressFromCache */.X)()
        });
        if (!Object.keys(postFlagWikiData).includes("error")) {
            toast({
                title: "Your report has been successfully submitted!",
                status: "success",
                duration: 5000,
                isClosable: true
            });
            onClose();
        } else {
            toast({
                title: "There was an error submitting your report.",
                status: "error",
                duration: 5000,
                isClosable: true
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
        isOpen: isOpen,
        onClose: onClose,
        isCentered: true,
        size: {
            base: "md",
            md: "2xl"
        },
        motionPreset: "slideInBottom",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalContent */.hz, {
                mx: {
                    base: "15px",
                    md: "0"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: postFlagHandler,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalHeader */.xB, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    children: "Report"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontWeight: 500,
                                    mt: "3",
                                    pb: "3",
                                    fontSize: {
                                        base: "sm",
                                        md: "md"
                                    },
                                    borderBottomWidth: "1px",
                                    borderBottomColor: "wikiFlagTextBorderColor",
                                    color: "wikiFlagTextColor",
                                    children: "Please, in a few words, write about what you would like to be reported in the text box below."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalBody */.fe, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_dist_index_esm/* Textarea */.g, {
                                fontWeight: 400,
                                fontSize: "sm",
                                minH: "200px",
                                color: "wikiFlagTextAreaColor",
                                borderColor: "wikiFlagTextAreaBorderColor",
                                placeholder: "Write your text here....",
                                name: "report-content",
                                onChange: (e)=>setFlagContent(e.currentTarget.value)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalFooter */.mz, {
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                type: "submit",
                                background: "brandLinkColor",
                                fontSize: "sm",
                                fontWeight: "400",
                                w: {
                                    base: "full",
                                    md: "initial"
                                },
                                disabled: flagContent.trim().length === 0,
                                children: "Confirm"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const WikiFlaggingSystem = (param)=>{
    let { id  } = param;
    const { isOpen , onOpen , onClose  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
    const toast = (0,toast_dist_index_esm/* useToast */.pm)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isOpen && (0,getUserAddressFromCache/* getUserAddressFromCache */.X)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlaggingSystemModal, {
                onClose: onClose,
                isOpen: isOpen,
                id: id
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                mt: {
                    base: "5",
                    lg: "10"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    direction: {
                        base: "column",
                        md: "row"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            as: "span",
                            children: "See something wrong? "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                            as: "span",
                            ml: {
                                base: "0",
                                md: "1"
                            },
                            color: "brandLinkColor",
                            cursor: "pointer",
                            display: "flex",
                            onClick: ()=>{
                                if ((0,getUserAddressFromCache/* getUserAddressFromCache */.X)()) {
                                    onOpen();
                                } else {
                                    toast({
                                        title: "Please, login to report this wiki's content.",
                                        status: "error",
                                        duration: 5000,
                                        isClosable: true
                                    });
                                }
                            },
                            _dark: {
                                color: "brand.800"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    as: "span",
                                    children: "Report to us."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                    as: "span",
                                    ml: "5px",
                                    alignItems: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                        fontSize: {
                                            base: "md",
                                            sm: "lg"
                                        },
                                        as: ri_index_esm/* RiFlagFill */.msm
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/WikiMainContent.tsx














const MarkdownRender = /*#__PURE__*/ react.memo((param)=>{
    let { wiki  } = param;
    store/* store.dispatch */.h.dispatch({
        type: "citeMarks/reset"
    });
    store/* store.dispatch */.h.dispatch({
        type: "toc/reset"
    });
    const referencesString = (0,react.useMemo)(()=>{
        var ref;
        return (ref = (0,getWikiFields/* getWikiMetadataById */.lU)(wiki, build_module/* CommonMetaIds.REFERENCES */.wA.REFERENCES)) === null || ref === void 0 ? void 0 : ref.value;
    }, [
        wiki
    ]);
    if (!wiki.content) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
        remarkPlugins: [
            remark_gfm/* default */.Z
        ],
        components: {
            h1: addToTOC,
            h2: addToTOC,
            h3: addToTOC,
            h4: addToTOC,
            h5: addToTOC,
            h6: addToTOC,
            a: (props)=>customLinkRenderer({
                    ...props,
                    referencesString
                }),
            img: customImageRender,
            table: customTableRenderer
        },
        children: wiki.content
    });
});
const WikiMainContent = (param)=>{
    let { wiki  } = param;
    var ref;
    const { colorMode  } = (0,color_mode_dist_index_esm/* useColorMode */.If)();
    let content = (wiki === null || wiki === void 0 ? void 0 : wiki.content.replace(/<br( )*\/?>/g, "\n")) || "";
    const matchRegex = /\$\$widget\d(.*?\))\$\$/;
    (ref = content.match(new RegExp(matchRegex, "g"))) === null || ref === void 0 ? void 0 : ref.forEach((match)=>{
        var ref;
        const widgetContent = (ref = match.match(matchRegex)) === null || ref === void 0 ? void 0 : ref[1];
        if (widgetContent) {
            content = content.replaceAll(match, widgetContent);
        }
    });
    const modifiedContentWiki = {
        ...wiki,
        content
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        py: 4,
        px: {
            base: 4,
            md: 6,
            xl: 12
        },
        pr: {
            md: 15,
            xl: 12
        },
        maxW: {
            base: "100%",
            xl: "900px"
        },
        mx: "auto",
        minH: {
            base: "unset",
            xl: "calc(100vh - 70px)"
        },
        mb: {
            xl: "3rem"
        },
        borderColor: "rankingListBorder",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                my: 8,
                children: wiki === null || wiki === void 0 ? void 0 : wiki.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                className: "".concat((markdown_module_default()).markdownBody, " ").concat(colorMode === "dark" && (markdown_module_default()).markdownBodyDark),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownRender, {
                        wiki: modifiedContentWiki
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiFlaggingSystem, {
                        id: wiki.id
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var WikiPage_WikiMainContent = (/*#__PURE__*/react.memo(WikiMainContent));

// EXTERNAL MODULE: ./src/store/hook.ts
var hook = __webpack_require__("./src/store/hook.ts");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/WikiReferences.tsx





const WikiReferences = (param)=>{
    let { references  } = param;
    const [currentLocationHash, setCurrentLocationHash] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        const onHashChanged = ()=>{
            setCurrentLocationHash(window.location.hash);
        };
        window.addEventListener("hashchange", onHashChanged);
        return ()=>{
            window.removeEventListener("hashchange", onHashChanged);
        };
    }, []);
    const citeMarks = (0,hook/* useAppSelector */.C)((state)=>state.citeMarks);
    if (references.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        borderTopWidth: "1px",
        p: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                my: 4,
                p: 2,
                fontWeight: "medium",
                children: "REFERENCES"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                mb: 8,
                columns: [
                    1,
                    2,
                    2,
                    3
                ],
                spacing: 4,
                children: references.map((ref, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* LinkBox */.fG, {
                        display: "flex",
                        id: "cite-id-".concat(ref.id),
                        bg: currentLocationHash === "#cite-id-".concat(ref.id) ? "pink.50" : "transparent",
                        _dark: {
                            bg: currentLocationHash === "#cite-id-".concat(ref.id) ? "gray.700" : "transparent"
                        },
                        borderRadius: 4,
                        p: 2,
                        scrollMarginTop: "20vh",
                        gap: 2,
                        maxW: "400px",
                        _hover: {
                            bg: "gray.50",
                            _dark: {
                                bg: "gray.900"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                color: "brandLinkColor",
                                children: [
                                    "[",
                                    index + 1,
                                    "] "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                        flexWrap: "wrap",
                                        gap: 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* Tag */.Vp, {
                                                colorScheme: "brand",
                                                as: "h3",
                                                size: "sm",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOverlay/* default */.Z, {
                                                    fontWeight: "500",
                                                    isExternal: true,
                                                    p: "0 !important",
                                                    href: ref.url,
                                                    rel: "nofollow",
                                                    children: new URL(ref.url).hostname
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                                flexWrap: "wrap",
                                                ml: "0 !important",
                                                columnGap: 2,
                                                children: citeMarks[ref.id] && Array.from(Array(citeMarks[ref.id])).map((_, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Link */.rU, {
                                                        href: "#cite-mark-".concat(ref.id, "-").concat(i + 1),
                                                        color: "brandLinkColor",
                                                        ml: "0 !important",
                                                        fontWeight: "medium",
                                                        fontSize: "sm",
                                                        whiteSpace: "nowrap",
                                                        children: [
                                                            "↑ ",
                                                            index + 1,
                                                            ".",
                                                            i + 1
                                                        ]
                                                    }, i))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        children: ref.description
                                    }),
                                    ref.timestamp && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        opacity: 0.6,
                                        fontSize: "sm",
                                        children: new Date(ref.timestamp).toLocaleDateString("en-US", {
                                            month: "short",
                                            day: "numeric",
                                            year: "numeric"
                                        })
                                    })
                                ]
                            })
                        ]
                    }, ref.id))
            })
        ]
    });
};
/* harmony default export */ var WikiPage_WikiReferences = (WikiReferences);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var media_query_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/media-query/dist/index.esm.js");
// EXTERNAL MODULE: ./src/components/StaticElement.tsx
var StaticElement = __webpack_require__("./src/components/StaticElement.tsx");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/WikiTableOfContents.tsx







const WikiTableOfContents = (param)=>{
    let { isAlertAtTop  } = param;
    const toc = (0,hook/* useAppSelector */.C)((state)=>state.toc);
    const { asPath , query , push  } = (0,next_router.useRouter)();
    const { slug  } = query;
    // get the link id if available to scroll to the correct position
    (0,react.useEffect)(()=>{
        if (!(toc.length === 0)) {
            const linkId = asPath.split("#")[1];
            if (linkId) push("/wiki/".concat(slug, "#").concat(linkId));
        }
    }, [
        asPath
    ]);
    const { colorMode  } = (0,color_mode_dist_index_esm/* useColorMode */.If)();
    const { isOpen , onToggle  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
    const isDefaultOpen = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)({
        base: false,
        xs: true,
        xl: false
    });
    const [activeId, setActiveId] = (0,react.useState)();
    // the below ref is used to store all the heading that are in view
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const headingElementsRef = (0,react.useRef)({});
    (0,react.useEffect)(()=>{
        // get all the heading elements
        const headingElements = Array.from(document.querySelectorAll("h1, h2, h3, h4, h5, h6"));
        // defining callback function for intersection observer
        // this function will be called when the heading element is in view
        // hence when the heading element is in view,
        // we will set the activeId to the id of the heading element
        const callback = (headings)=>{
            headingElementsRef.current = headings.reduce((map, headingElement)=>{
                map[headingElement.target.id] = headingElement;
                return map;
            }, headingElementsRef.current);
            // get the id of the heading element that is in view
            const visibleHeadings = [];
            Object.keys(headingElementsRef.current).forEach((key)=>{
                const headingElement = headingElementsRef.current[key];
                if (headingElement.isIntersecting) visibleHeadings.push(headingElement);
            });
            const getIndexFromId = (id)=>headingElements.findIndex((heading)=>heading.id === id);
            // setting the activeId to the id of the heading element that is in view
            if (visibleHeadings.length === 1) {
                setActiveId(visibleHeadings[0].target.id);
            } else if (visibleHeadings.length > 1) {
                // if there are multiple heading elements in view then set heading near to top as active
                let closestHeading = visibleHeadings[0];
                visibleHeadings.forEach((headingElement)=>{
                    if (closestHeading === undefined || getIndexFromId(closestHeading.target.id) > getIndexFromId(headingElement.target.id)) {
                        closestHeading = headingElement;
                    }
                });
                setActiveId(closestHeading.target.id);
            }
        };
        // creating intersection observer instance and observing the heading elements
        const observer = new IntersectionObserver(callback, {
            rootMargin: "-100px 0px 0px 0px"
        });
        headingElements.forEach((element)=>observer.observe(element));
        return ()=>observer.disconnect();
    }, [
        setActiveId,
        toc
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if (!activeId) setActiveId((ref = toc[0]) === null || ref === void 0 ? void 0 : ref.id);
    }, [
        activeId,
        toc
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isOpen === isDefaultOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
            display: {
                base: "none",
                xl: "block"
            },
            borderLeftWidth: "1px",
            w: "20vw",
            px: 6,
            py: "30px",
            ml: "0 !important",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                spacing: 4,
                align: "start",
                position: "sticky",
                top: "calc(70px + 30px + 2px)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                        w: "100%",
                        justify: "end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                            "aria-label": "Toggle Table of Contents",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiMenu3Fill */.dQh, {}),
                            onClick: onToggle
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticElement/* StaticContent */.Y, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
                            as: "nav",
                            spacing: 4,
                            h: "calc(100vh - (70px + 90px))",
                            overflowY: "scroll",
                            pr: 4,
                            w: "100%",
                            align: "start",
                            css: {
                                "&::-webkit-scrollbar": {
                                    width: "4px"
                                },
                                "&::-webkit-scrollbar-track": {
                                    width: "6px"
                                },
                                "&::-webkit-scrollbar-thumb": {
                                    background: colorMode === "light" ? "#0000002a" : "#3f444e",
                                    borderRadius: "24px"
                                }
                            },
                            children: toc.map((param)=>/*#__PURE__*/ {
                                let { level , id , title  } = param;
                                return (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                    pl: "calc(".concat((level - 1) * 20, "px)"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        color: activeId === id ? "brandLinkColor" : "unset",
                                        boxShadow: activeId === id ? "-2px 0px 0px 0px #ff5caa" : "0",
                                        outlineColor: "brandLinkColor",
                                        pl: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
                                            href: "#".concat(id),
                                            children: title
                                        })
                                    })
                                }, id);
                            })
                        })
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
            display: {
                base: "none",
                md: "block"
            },
            pos: "absolute",
            right: "24px",
            top: "calc(70px + ".concat(isAlertAtTop ? "80px" : "32px", ")"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                "aria-label": "Toggle Table of Contents",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiMenu3Fill */.dQh, {}),
                onClick: onToggle
            })
        })
    });
};
/* harmony default export */ var WikiPage_WikiTableOfContents = (/*#__PURE__*/react.memo(WikiTableOfContents));

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/WikiMarkup.tsx















//TODO: use Wiki partial
const MobileMeta = (wiki)=>{
    var ref;
    const { metadata , media , id , categories  } = wiki;
    const twitterLink = (ref = metadata.find((meta)=>meta.id === build_module/* CommonMetaIds.TWITTER_PROFILE */.wA.TWITTER_PROFILE)) === null || ref === void 0 ? void 0 : ref.value;
    const userAddress = (0,getUserAddressFromCache/* getUserAddressFromCache */.X)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
        p: {
            base: 4,
            md: 6
        },
        pr: {
            md: 15,
            xl: 0
        },
        mx: {
            base: "auto",
            md: 0
        },
        w: {
            base: "100%",
            xl: "40%",
            "2xl": "50%"
        },
        display: {
            base: "block",
            xl: "none"
        },
        spacing: 6,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightComponents_ContentFeedback, {
                choice: true,
                contentId: id,
                userId: userAddress
            }),
            !!twitterLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightComponents_TwitterTimeline, {
                url: twitterLink
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedWikis, {
                wikiId: id,
                category: categories[0].id
            }),
            media && media.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedMedia, {
                media: media
            })
        ]
    });
};
const WikiMarkup = (param)=>{
    let { wiki , ipfs  } = param;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
        align: "stretch",
        justify: "stretch",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                w: "100%",
                justify: "space-between",
                direction: {
                    base: "column",
                    md: "row"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiPage_WikiActionBar, {
                        wiki: wiki
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        w: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                w: "100%",
                                justify: "space-between",
                                direction: {
                                    base: "column-reverse",
                                    xl: "row"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiPage_WikiMainContent, {
                                        wiki: wiki
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiPage_WikiInsights, {
                                        wiki: wiki,
                                        ipfs: ipfs
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSize: "4xl",
                                        fontWeight: "bold",
                                        mt: 8,
                                        mb: -4,
                                        display: {
                                            xl: "none"
                                        },
                                        textAlign: {
                                            base: "center",
                                            md: "left"
                                        },
                                        px: {
                                            base: 4,
                                            md: 6
                                        },
                                        children: wiki === null || wiki === void 0 ? void 0 : wiki.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* chakra.div */.m$.div, {
                                display: {
                                    base: "block",
                                    xl: "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMeta, {
                                    metadata: wiki.metadata,
                                    media: wiki.media,
                                    id: wiki.id,
                                    categories: wiki.categories
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiPage_WikiReferences, {
                                references: JSON.parse(((ref = (0,getWikiFields/* getWikiMetadataById */.lU)(wiki, build_module/* CommonMetaIds.REFERENCES */.wA.REFERENCES)) === null || ref === void 0 ? void 0 : ref.value) || "[]")
                            })
                        ]
                    })
                ]
            }),
            (wiki === null || wiki === void 0 ? void 0 : wiki.content.includes("# ")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiPage_WikiTableOfContents, {})
        ]
    });
};


/***/ }),

/***/ "./src/hooks/useWeb3Token.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useWeb3Token; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/wagmi/dist/index.js");
/* harmony import */ var _everipedia_web3_signer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@everipedia/web3-signer/dist/src/index.js");



const useWeb3Token = ()=>{
    const [token, setToken] = react__WEBPACK_IMPORTED_MODULE_0__.useState();
    const [loading, setLoading] = react__WEBPACK_IMPORTED_MODULE_0__.useState(false);
    const [error, setError] = react__WEBPACK_IMPORTED_MODULE_0__.useState();
    const [isReSignToken, reSignToken] = react__WEBPACK_IMPORTED_MODULE_0__.useState(false);
    const { data: signer  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_2__/* .useWalletClient */ .py)();
    const generateNewTokenAndStore = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async ()=>{
        if (!signer) return;
        const freshToken = await (0,_everipedia_web3_signer__WEBPACK_IMPORTED_MODULE_1__/* .sign */ .Xx)((msg)=>signer.signMessage({
                message: msg
            }), {
            statement: "Welcome to IQ.Wiki ! Click to sign in and accept the IQ.Wiki Terms of Service: https://everipedia.com/static/terms. This request will not trigger a blockchain transaction or cost any gas fees. Your authentication status will reset after 24 hours. ",
            expires_in: "1h"
        });
        localStorage.setItem("USER_TOKEN", freshToken);
        setToken(freshToken);
    }, [
        signer
    ]);
    const fetchStoredToken = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        const storedToken = localStorage.getItem("USER_TOKEN");
        if (storedToken) {
            const { address , body  } = (0,_everipedia_web3_signer__WEBPACK_IMPORTED_MODULE_1__/* .verify */ .T)(storedToken);
            if (address && body) {
                setToken(storedToken);
            }
        } else {
            throw new Error("No token found");
        }
    }, []);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(()=>{
        const retrieveWeb3Token = async ()=>{
            if (isReSignToken) setError("");
            else reSignToken(false);
            const generateNewToken = async ()=>{
                setLoading(true);
                try {
                    await generateNewTokenAndStore();
                } catch (e) {
                    setError(e);
                }
                setLoading(false);
            };
            try {
                fetchStoredToken();
            } catch (e) {
                await generateNewToken();
            }
        };
        retrieveWeb3Token();
    }, [
        signer,
        isReSignToken,
        generateNewTokenAndStore,
        fetchStoredToken
    ]);
    return {
        token,
        loading,
        reSignToken,
        error
    };
};


/***/ }),

/***/ "./src/styles/markdown.module.css":
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordionDisplay":"markdown_accordionDisplay__BD_VP","accordionUnDisplay":"markdown_accordionUnDisplay__f_syU","accordionOpen":"markdown_accordionOpen__G9_eQ","accordionClose":"markdown_accordionClose__NjRB7","markdownBody":"markdown_markdownBody__i1xqq","table-container":"markdown_table-container__Y0NNm","anchor":"markdown_anchor__V_ihR","no-list":"markdown_no-list__6FH8U","markdownBodyDark":"markdown_markdownBodyDark__P4Pc5"};

/***/ }),

/***/ "?d36c":
/***/ (function() {

/* (ignored) */

/***/ })

}]);